import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _uniqueId from'lodash/uniqueId';import React,{useState,useRef,forwardRef,useEffect,Children,createContext,useContext,useMemo,useLayoutEffect,useCallback,isValidElement}from'react';import {useStyles as useStyles$2,Caption,useTheme as useTheme$1,useFioriStyles as useFioriStyles$1,IconButton,Description,Popover,Tag,FlatButton,Divider,DatePicker,fileUtils,Button,Icon as Icon$1}from'@signavio/ui';import {Glyph,Box as Box$1,TextInput as TextInput$2,NumberInput as NumberInput$2,EmailInput as EmailInput$2,UrlInput as UrlInput$2,Textarea as Textarea$2,Stack as Stack$1,padding,spacing as spacing$1,font,size,zIndex,shadow as shadow$1,border,sanitizeNumberInput,parseNumberString,Date as Date$1,DateTime,DurationInput as DurationInput$2,Time,File,transition}from'@signavio/ui/core';import _extends from'@babel/runtime/helpers/extends';import _defineProperty from'@babel/runtime/helpers/defineProperty';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import mergeRefs from'react-merge-refs';import invariant from'invariant';import Stick,{PortalContext}from'react-stick';import useStyles$3,{inline}from'substyle';import _toConsumableArray from'@babel/runtime/helpers/toConsumableArray';import {sortableHandle,SortableContainer,SortableElement}from'react-sortable-hoc';import'dwnld-attr-polyfill';import'lodash/merge';import Color from'color';import {addMinutes}from'date-fns';import {useDebouncedCallback}from'use-debounce';import useDelayedState from'use-delayed-state';import Mousetrap from'mousetrap';import {useResizeObserver}from'use-events';function InputFooter(_ref) {
  var htmlFor = _ref.htmlFor,
    hint = _ref.hint,
    error = _ref.error;
  var styles = useStyles$2(defaultStyles$k, {});
  if (error) {
    return /*#__PURE__*/React.createElement("div", _extends({
      id: descriptionId(htmlFor)
    }, styles('error'), {
      "data-qa": "error"
    }), /*#__PURE__*/React.createElement(Caption, null, error));
  }
  if (hint) {
    return /*#__PURE__*/React.createElement("div", _extends({
      id: descriptionId(htmlFor)
    }, styles('hint'), {
      "data-qa": "hint"
    }), /*#__PURE__*/React.createElement(Caption, null, hint));
  }
  return null;
}
var descriptionId = function descriptionId(inputId) {
  return "".concat(inputId, "__description");
};
var defaultStyles$k = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    hint: {
      color: color.text.inactive
    },
    error: {
      color: color.danger.base
    }
  };
};function InputContainer(_ref) {
  var htmlFor = _ref.htmlFor,
    children = _ref.children,
    controls = _ref.controls,
    focussed = _ref.focussed,
    error = _ref.error,
    hint = _ref.hint,
    icon = _ref.icon,
    clearable = _ref.clearable,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    onClear = _ref.onClear,
    stickControlsToTop = _ref.stickControlsToTop,
    textarea = _ref.textarea;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var inputEl = useRef(null);
  var showClearable = clearable && !readOnly && !disabled;
  var theme = useTheme$1();
  var fioriStyles = useFioriStyles$1();
  var defaultStyles = function defaultStyles(_ref2) {
    var color = _ref2.color,
      spacing = _ref2.spacing,
      font = _ref2.font,
      border = _ref2.border;
    return {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      inputContainer: {
        display: 'flex',
        minHeight: '40px',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: color.shading.onLight,
        borderRadius: border.tab.borderRadius.regular,
        border: 'none',
        // Implement the bottom border using a box-shadow as it
        // changes in size when the input becomes active and we
        // don't want the component to grow in size as this
        // would have a negative impact on UX.
        boxShadow: "0px -1px ".concat(color.text.inactive, " inset")
      },
      '&alignStart': {
        inputContainer: {
          alignItems: 'flex-start'
        }
      },
      '&stickControlsToTop': {
        controls: {
          alignSelf: 'flex-start'
        }
      },
      icon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: spacing.xsmall,
        color: color.text.disabled
      },
      textareaIcon: {
        marginTop: spacing.xxsmall
      },
      controls: {
        display: 'flex'
      },
      input: {
        color: color.text.base,
        lineHeight: font.size.xxlarge,
        fontSize: font.size.normal,
        overflow: 'auto',
        background: 'none',
        border: 'none',
        alignSelf: 'stretch',
        paddingLeft: spacing.xsmall,
        paddingRight: spacing.xsmall,
        textOverflow: 'ellipsis',
        '::placeholder': {
          color: color.text.disabled,
          // Firefox adds a lower opacity to the placeholder, so we use opacity: 1 to fix this.
          opacity: 1
        }
      },
      '&focus': {
        inputContainer: {
          backgroundColor: color.active.secondary,
          boxShadow: "0px -2px ".concat(fioriStyles ? color.primary.base : color.secondary.base, " inset")
        },
        '&hover': {
          inputContainer: {
            backgroundColor: color.active.secondary
          }
        }
      },
      '&hover': {
        inputContainer: {
          backgroundColor: color.hover.base
        }
      },
      '&hasError': {
        inputContainer: {
          boxShadow: "0px -1px ".concat(color.danger.base, " inset")
        }
      },
      '&disabled': {
        inputContainer: {
          backgroundColor: 'transparent',
          boxShadow: "0px -1px ".concat(color.divider.base, " inset")
        },
        input: {
          color: color.text.disabled
        },
        '&hover': {
          inputContainer: {
            backgroundColor: 'transparent'
          }
        }
      },
      '&readOnly': {
        inputContainer: {
          backgroundColor: 'transparent',
          boxShadow: "0px -1px ".concat(color.divider.base, " inset")
        },
        input: {
          color: color.text.base
        },
        '&hover': {
          inputContainer: {
            backgroundColor: 'transparent'
          }
        }
      }
    };
  };
  var styles = useStyles$2(defaultStyles(theme), {}, {
    '&hover': hover,
    '&focus': focussed,
    '&hasError': !!error,
    '&disabled': disabled,
    '&readOnly': readOnly,
    '&stickControlsToTop': !!stickControlsToTop,
    '&alignStart': !!textarea
  });
  function focusInput() {
    if (inputEl.current) {
      inputEl.current.focus();
    }
  }
  return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement("div", _extends({}, styles('inputContainer'), {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }), icon && /*#__PURE__*/React.createElement("div", _extends({}, styles('icon'), textarea && styles('textareaIcon')), typeof icon === 'string' ? /*#__PURE__*/React.createElement(Glyph, null, icon) : icon), children(inputEl, styles('input')), (showClearable || controls) && /*#__PURE__*/React.createElement("div", styles('controls'), showClearable && /*#__PURE__*/React.createElement("div", styles('clearable'), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Clear input",
    tabIndex: -1,
    icon: "reset",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear();
      focusInput();
    }
  })), controls)), (error || hint) && /*#__PURE__*/React.createElement(Box$1, {
    marginTop: "xxxsmall",
    marginBottom: "xxxsmall",
    marginLeft: "xsmall",
    marginRight: "xsmall"
  }, /*#__PURE__*/React.createElement(InputFooter, {
    htmlFor: htmlFor,
    error: error,
    hint: hint
  })));
}function Label(_ref) {
  var id = _ref.id,
    label = _ref.label,
    labelPosition = _ref.labelPosition,
    children = _ref.children,
    description = _ref.description,
    required = _ref.required,
    labelledBy = _ref.labelledBy;
  var _useState = useState(function () {
      return id || _uniqueId('ui_input');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    fieldId = _useState2[0];
  var _useState3 = useState(function () {
      return labelledBy || _uniqueId('ui_label');
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    labelId = _useState4[0];
  var styles = useStyles$2(defaultStyles$j, {}, _defineProperty({
    '&isRequired': labelPosition === 'top' && required
  }, "&label-".concat(labelPosition), true));
  if (!label) {
    return typeof children === 'function' ? children(fieldId, labelId) : children;
  }
  return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement("div", styles('labelContainer'), required && labelPosition === 'top' && /*#__PURE__*/React.createElement("span", styles('asterisk'), "*"), /*#__PURE__*/React.createElement("label", _extends({}, styles('label'), {
    id: labelId,
    htmlFor: fieldId,
    "aria-describedby": description
  }), required && labelPosition === 'left' && /*#__PURE__*/React.createElement("span", styles('asterisk'), "*"), label, description && /*#__PURE__*/React.createElement(Description, null, description))), /*#__PURE__*/React.createElement("div", styles('input'), typeof children === 'function' ? children(fieldId, labelId) : children));
}
var defaultStyles$j = function defaultStyles(_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing,
    font = _ref2.font;
  return {
    display: 'flex',
    labelContainer: {
      display: 'flex',
      paddingLeft: spacing.xsmall,
      paddingRight: spacing.xsmall,
      wordBreak: 'break-word',
      fontSize: font.body.fontSize,
      color: color.text.inactive
    },
    '&label-top': {
      // styles needed when the label is on top
      flexDirection: 'column',
      alignItems: 'flex-start',
      labelContainer: {
        width: '100%',
        paddingBottom: spacing.xxxsmall
      },
      label: {
        width: '100%'
      },
      input: {
        alignSelf: 'stretch'
      }
    },
    '&label-left': {
      // styles needed when the label is on the left
      alignItems: 'stretch',
      flexDirection: 'row',
      labelContainer: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        textAlign: 'right',
        width: '40%',
        paddingLeft: 0
      },
      input: {
        width: '60%'
      }
    },
    '&is-required': {
      labelContainer: {
        paddingLeft: 0
      }
    },
    asterisk: {
      paddingRight: 6,
      width: spacing.xsmall,
      color: color.danger.base
    }
  };
};function InlineTag(_ref) {
  var tagText = _ref.tagText,
    popoverText = _ref.popoverText;
  if (!tagText) {
    return null;
  }
  return popoverText ? /*#__PURE__*/React.createElement(Popover, {
    popover: popoverText,
    position: "top"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingRight: '6px'
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    small: true
  }, tagText))) : /*#__PURE__*/React.createElement("div", {
    style: {
      paddingRight: '6px'
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    small: true
  }, tagText));
}var _excluded$m = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "clearable", "value", "readOnly", "placeholder", "controls", "readOnlyPlaceholder", "tag"];
function TextInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    value = _ref.value,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    placeholder = _ref.placeholder,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    tag = _ref.tag,
    rest = _objectWithoutProperties(_ref, _excluded$m);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      controls: controls,
      htmlFor: id,
      clearable: clearable && Boolean(value),
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (internalRef, styles) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput$2, _extends({}, rest, {
        style: styles,
        "aria-describedby": descriptionId(id),
        required: required,
        id: id,
        ref: mergeRefs([internalRef, ref]),
        value: value,
        onChange: onChange,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": error != null
      })), tag && /*#__PURE__*/React.createElement(InlineTag, {
        tagText: tag.tagText,
        popoverText: tag.popoverText
      }));
    });
  });
}
var TextInput$1 = /*#__PURE__*/forwardRef(TextInput);var _excluded$l = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "readOnly", "clearable", "controls", "value", "placeholder", "readOnlyPlaceholder"];
function NumberInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    value = _ref.value,
    placeholder = _ref.placeholder,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$l);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      htmlFor: id,
      controls: controls,
      clearable: clearable && value != null,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (inputRef, styles) {
      return /*#__PURE__*/React.createElement(NumberInput$2, _extends({}, rest, {
        "aria-describedby": descriptionId(id),
        "aria-invalid": !!error,
        style: styles,
        ref: mergeRefs([ref, inputRef]),
        id: id,
        value: value,
        required: required,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: onChange,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly
      }));
    });
  });
}
var NumberInput$1 = /*#__PURE__*/forwardRef(NumberInput);var _excluded$k = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "clearable", "readOnly", "controls", "value", "readOnlyPlaceholder", "placeholder"];
function EmailInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    value = _ref.value,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    placeholder = _ref.placeholder,
    rest = _objectWithoutProperties(_ref, _excluded$k);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      controls: controls,
      htmlFor: id,
      clearable: clearable && value != null,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (inputRef, styles) {
      return /*#__PURE__*/React.createElement(EmailInput$2, _extends({}, rest, {
        style: styles,
        "aria-describedby": descriptionId(id),
        ref: mergeRefs([ref, inputRef]),
        id: id,
        value: value,
        required: required,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: onChange,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": !!error
      }));
    });
  });
}
var EmailInput$1 = /*#__PURE__*/forwardRef(EmailInput);var _excluded$j = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "readOnly", "clearable", "controls", "value", "placeholder", "readOnlyPlaceholder"];
function UrlInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    value = _ref.value,
    placeholder = _ref.placeholder,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  var style = useStyles$2(defaultStyles$i, {});
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id, labelId) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      htmlFor: id,
      clearable: clearable && value != null,
      controls: controls,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (inputRef, styles) {
      return readOnly && value ? /*#__PURE__*/React.createElement("a", _extends({}, rest, style('link'), {
        href: value,
        target: "_blank",
        rel: "noreferrer",
        "aria-describedby": descriptionId(id),
        "aria-labelledby": labelId
      }), value && value.replace(/^.*?:\/+/i, '')) : /*#__PURE__*/React.createElement(UrlInput$2, _extends({}, rest, {
        style: styles,
        "aria-describedby": descriptionId(id),
        ref: mergeRefs([ref, inputRef]),
        id: id,
        value: value,
        required: required,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: onChange,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": !!error
      }));
    });
  });
}
var defaultStyles$i = function defaultStyles(_ref2) {
  var font = _ref2.font,
    spacing = _ref2.spacing,
    color = _ref2.color;
  return {
    link: {
      flexGrow: 1,
      color: color.primary.base,
      fontSize: font.size.normal,
      paddingLeft: spacing.xsmall,
      paddingRight: spacing.xsmall,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }
  };
};
var UrlInput$1 = /*#__PURE__*/forwardRef(UrlInput);var _excluded$i = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "readOnly", "clearable", "value", "controls", "placeholder", "readOnlyPlaceholder", "minRows"];
function Textarea(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    value = _ref.value,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    placeholder = _ref.placeholder,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    _ref$minRows = _ref.minRows,
    minRows = _ref$minRows === void 0 ? 3 : _ref$minRows,
    rest = _objectWithoutProperties(_ref, _excluded$i);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  var _useTheme = useTheme$1(),
    spacing = _useTheme.spacing;
  var isClearable = clearable && Boolean(value);
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      controls: controls,
      htmlFor: id,
      clearable: isClearable,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      },
      stickControlsToTop: true
    }, function (inputRef, styles) {
      var derivedStyle = inline(styles, {
        paddingTop: spacing.xxsmall,
        paddingBottom: spacing.xxsmall,
        paddingRight: spacing.xsmall
      });
      return /*#__PURE__*/React.createElement(Textarea$2, _extends({}, rest, derivedStyle, {
        "aria-describedby": descriptionId(id),
        ref: mergeRefs([ref, inputRef]),
        minRows: minRows,
        id: id,
        value: value,
        required: required,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: onChange,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": !!error
      }));
    });
  });
}
var Textarea$1 = /*#__PURE__*/forwardRef(Textarea);function BooleanField(_ref) {
  var id = _ref.id,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    hint = _ref.hint,
    error = _ref.error,
    label = _ref.label,
    value = _ref.value,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    yesLabel = _ref.yesLabel,
    noLabel = _ref.noLabel,
    readOnly = _ref.readOnly,
    emptyLabel = _ref.emptyLabel,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    icon = _ref.icon,
    tabIndex = _ref.tabIndex;
  var _useState = useState(function () {
      return _uniqueId('ui_label');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    labelledById = _useState2[0];
  if (readOnly || disabled) {
    var displayValue = null;
    if (value === true) {
      displayValue = yesLabel;
    }
    if (value === false) {
      displayValue = noLabel;
    }
    return /*#__PURE__*/React.createElement(TextInput$1, {
      readOnly: true,
      label: label,
      id: id,
      labelPosition: labelPosition,
      description: description,
      hint: hint,
      error: error,
      value: displayValue,
      required: required,
      placeholder: emptyLabel,
      clearable: false,
      controls: controls,
      icon: icon
    });
  }
  var handleChange = function handleChange(event, baseValue) {
    event.preventDefault();
    if (!onChange) {
      return;
    }
    if (value === baseValue) {
      if (clearable) {
        onChange(null);
      }
      return;
    }
    onChange(baseValue);
  };
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required,
    labelledBy: labelledById
  }, function (id, labelId) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$1, {
      role: "group",
      "aria-labelledby": labelledById,
      "aria-describedby": descriptionId(id),
      direction: "horizontal",
      spacing: "xxxsmall"
    }, /*#__PURE__*/React.createElement(FlatButton, {
      active: value,
      "aria-pressed": !!value,
      disabled: disabled,
      tabIndex: tabIndex,
      onClick: function onClick(event) {
        return handleChange(event, true);
      }
    }, yesLabel), /*#__PURE__*/React.createElement(FlatButton, {
      active: value === false,
      "aria-pressed": value === false,
      disabled: disabled,
      tabIndex: tabIndex,
      onClick: function onClick(event) {
        return handleChange(event, false);
      }
    }, noLabel)), (hint || error) && /*#__PURE__*/React.createElement(Box$1, {
      marginTop: "xxxsmall",
      marginBottom: "xxxsmall",
      marginLeft: "xsmall",
      marginRight: "xsmall"
    }, /*#__PURE__*/React.createElement(InputFooter, {
      htmlFor: id,
      hint: hint,
      error: error
    })));
  });
}function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Listbox(_ref) {
  var children = _ref.children,
    ownerId = _ref.ownerId,
    _ref$enableMultiSelec = _ref.enableMultiSelect,
    enableMultiSelect = _ref$enableMultiSelec === void 0 ? false : _ref$enableMultiSelec;
  var theme = useTheme$1();
  var styles = useStyles$2(defaultStyles$h(theme), {});
  return /*#__PURE__*/React.createElement(Box$1, {
    shadow: "menu",
    style: styles
  }, /*#__PURE__*/React.createElement("ul", _extends({}, styles('list'), {
    id: listboxId(ownerId),
    role: "listbox",
    tabIndex: -1,
    "aria-multiselectable": enableMultiSelect ? 'true' : 'false'
  }), children));
}
var listboxId = function listboxId(inputId) {
  return "".concat(inputId, "__listbox");
};
var defaultStyles$h = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return _objectSpread$7(_objectSpread$7({
    backgroundColor: color.surface,
    maxHeight: 300,
    overflow: 'hidden'
  }, border.modal), {}, {
    list: {
      marginTop: 0,
      marginBottom: 0,
      maxHeight: 300,
      overflow: 'auto',
      paddingLeft: 0,
      listStyle: 'none',
      outline: 'none',
      wordBreak: 'break-word'
    }
  });
};var _excluded$h = ["id", "expanded", "readOnly", "required", "disabled", "clearable", "icon", "error", "hint", "activeDescendant", "placeholder", "value", "tag", "controls", "textarea", "keepFilterValue", "onFilter", "onClear", "onChange", "onToggleMenu", "onSelectNext", "onSelectPrevious", "onSelectCurrent", "onFocus"];
function ComboInput(_ref, ref) {
  var id = _ref.id,
    expanded = _ref.expanded,
    readOnly = _ref.readOnly,
    required = _ref.required,
    disabled = _ref.disabled,
    clearable = _ref.clearable,
    icon = _ref.icon,
    error = _ref.error,
    hint = _ref.hint,
    activeDescendant = _ref.activeDescendant,
    placeholder = _ref.placeholder,
    value = _ref.value,
    tag = _ref.tag,
    controls = _ref.controls,
    textarea = _ref.textarea,
    keepFilterValue = _ref.keepFilterValue,
    onFilter = _ref.onFilter,
    onClear = _ref.onClear,
    _onChange = _ref.onChange,
    onToggleMenu = _ref.onToggleMenu,
    onSelectNext = _ref.onSelectNext,
    onSelectPrevious = _ref.onSelectPrevious,
    onSelectCurrent = _ref.onSelectCurrent,
    _onFocus = _ref.onFocus,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    filterValue = _useState2[0],
    setFilterValue = _useState2[1];
  var inputRef = useRef();
  var filterCallback = useRef(onFilter);
  var _useTheme = useTheme$1(),
    spacing = _useTheme.spacing;
  useEffect(function () {
    filterCallback.current = onFilter;
  }, [onFilter]);
  useEffect(function () {
    filterCallback.current(filterValue);
  }, [filterValue, onFilter]);
  useEffect(function () {
    if (keepFilterValue && value !== filterValue) {
      setFilterValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, keepFilterValue, expanded]);
  useEffect(function () {
    if (!keepFilterValue) {
      setFilterValue(null);
    } else {
      filterCallback.current('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded, keepFilterValue]);
  useEffect(function () {
    if (!inputRef.current) {
      return;
    }
    if (expanded) {
      inputRef.current.focus();
    } else {
      inputRef.current.blur();
    }
  }, [expanded]);
  var Component = textarea ? Textarea$2 : TextInput$2;
  return /*#__PURE__*/React.createElement(InputContainer, {
    htmlFor: id,
    controls: /*#__PURE__*/React.createElement(React.Fragment, null, !readOnly && /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": expanded ? 'Close select' : 'Open select',
      disabled: disabled,
      icon: expanded ? 'dropdown-close' : 'dropdown-open',
      onClick: function onClick() {
        return onToggleMenu(!expanded);
      },
      tabIndex: -1
    }), controls),
    clearable: expanded ? false : clearable,
    error: expanded ? null : error,
    icon: icon,
    hint: expanded ? null : hint,
    disabled: disabled,
    readOnly: readOnly,
    focussed: expanded,
    onClear: onClear,
    textarea: textarea
  }, function (styleRef, styles) {
    var derivedStyle = inline(styles, textarea ? {
      paddingTop: spacing.xxsmall,
      paddingBottom: spacing.xxsmall,
      paddingRight: spacing.xsmall,
      resize: 'none'
    } : {});
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({}, rest, derivedStyle, {
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-describedby": descriptionId(id),
      "aria-expanded": expanded ? 'true' : 'false',
      "aria-required": required ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-readonly": readOnly ? 'true' : 'false',
      "aria-invalid": error ? 'true' : 'false',
      "aria-owns": listboxId(id),
      "aria-activedescendant": activeDescendant !== null && activeDescendant !== void 0 ? activeDescendant : '',
      id: id,
      ref: mergeRefs([styleRef, inputRef, ref]),
      placeholder: placeholder,
      alt: expanded ? null : value,
      disabled: disabled || readOnly,
      value: expanded ? filterValue : value,
      onFocus: function onFocus(event) {
        if (!expanded) {
          onToggleMenu(true);
          if (_onFocus) {
            _onFocus(event);
          }
        }
      },
      onChange: function onChange(value) {
        if (_onChange) {
          _onChange(value);
        }
        setFilterValue(value);
      },
      onKeyDown: function onKeyDown(event) {
        if (event.key === 'Tab') {
          onToggleMenu(false);
        }
      },
      onKeyUp: function onKeyUp(event) {
        if (event.key === 'ArrowDown') {
          onSelectNext();
        } else if (event.key === 'ArrowUp') {
          onSelectPrevious();
        } else if (event.key === 'Enter' && !(textarea && event.shiftKey)) {
          onSelectCurrent();
        } else if (event.key === 'Escape') {
          onToggleMenu(false);
        }
      }
    }, textarea && {
      minRows: 1
    })), tag && /*#__PURE__*/React.createElement(InlineTag, {
      tagText: tag.tagText,
      popoverText: tag.popoverText
    }));
  });
}
var ComboInput$1 = /*#__PURE__*/forwardRef(ComboInput);function DisabledOption(_ref) {
  var selected = _ref.selected,
    children = _ref.children;
  var styles = useStyles$2(optionStyles$3, {});
  return /*#__PURE__*/React.createElement("li", _extends({}, styles, {
    role: "option",
    "aria-selected": selected ? 'true' : 'false',
    "aria-disabled": "true"
  }), children);
}
var optionStyles$3 = {
  cursor: 'not-allowed'
};var _excluded$g = ["id", "children", "selected", "disabled", "onSelect", "onMouseEnter"];
function Option$2(_ref) {
  var id = _ref.id,
    children = _ref.children,
    selected = _ref.selected,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    onMouseEnter = _ref.onMouseEnter,
    rest = _objectWithoutProperties(_ref, _excluded$g);
  var styles = useStyles$2(optionStyles$2, {}, {
    '&disabled': disabled
  });
  return (
    /*#__PURE__*/
    // Please fix me
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("li", _extends({}, rest, styles, {
      id: id,
      role: "option",
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      onClick: function onClick() {
        if (disabled) {
          return;
        }
        onSelect();
      },
      onMouseEnter: onMouseEnter
    }), children)
  );
}
var optionStyles$2 = function optionStyles(_ref2) {
  var color = _ref2.color;
  return {
    cursor: 'pointer',
    '&disabled': {
      color: color.text.disabled,
      cursor: 'default'
    }
  };
};function moveSelectionIndex(options, currentIndex, increment) {
  if (allOptionsDisabled(options)) {
    return currentIndex;
  }
  var newSelectionIndex = currentIndex;
  do {
    newSelectionIndex = (newSelectionIndex + increment + options.length) % options.length;
  } while (options[newSelectionIndex].props.disabled);
  return newSelectionIndex;
}
function allOptionsDisabled(options) {
  return options.every(function (_ref) {
    var disabled = _ref.props.disabled;
    return disabled;
  });
}function useFilteredOptions(options, filterCondition, excludeValueFilter) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    filterValue = _useState2[0],
    setFilterValue = _useState2[1];
  if (!filterValue) {
    return [options, filterValue, setFilterValue];
  }
  var defaultFilter = function defaultFilter(_ref) {
    var value = _ref.value,
      children = _ref.children,
      keywords = _ref.keywords;
    return excludeValueFilter ? filterChildren(children, filterValue) || filterKeywords(keywords, filterValue) : filterOptionValues(value, filterValue) || filterChildren(children, filterValue) || filterKeywords(keywords, filterValue);
  };
  var filteredOptions = options.filter(function (_ref2) {
    var _ref2$props = _ref2.props,
      value = _ref2$props.value,
      children = _ref2$props.children,
      _ref2$props$keywords = _ref2$props.keywords,
      keywords = _ref2$props$keywords === void 0 ? [] : _ref2$props$keywords;
    return filterCondition ? filterCondition({
      value: value,
      children: children,
      keywords: keywords
    }) : defaultFilter({
      value: value,
      children: children,
      keywords: keywords
    });
  });
  return [filteredOptions, filterValue, setFilterValue];
}
function filterOptionValues(value, filterValue) {
  return value.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
}
function filterKeywords(keywords, filterValue) {
  return keywords.some(function (keyword) {
    return keyword.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
  });
}
function filterChildren(children, filterValue) {
  return typeof children === 'string' && children.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
}var _excluded$f = ["id", "children", "disabled", "readOnly", "value", "placeholder", "label", "onSearch", "labelPosition", "error", "icon", "required", "onChange", "description", "hint", "emptyText", "clearable", "tag", "readOnlyPlaceholder", "excludeOptionValueFilter", "filterCondition", "autoFlipVertically", "customOption"],
  _excluded2 = ["id", "children", "selected", "hovered", "icon", "tag", "disabled", "onSelect", "onMouseEnter"];
function Select(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    value = _ref.value,
    placeholder = _ref.placeholder,
    label = _ref.label,
    onSearch = _ref.onSearch,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    error = _ref.error,
    icon = _ref.icon,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    onChange = _ref.onChange,
    description = _ref.description,
    hint = _ref.hint,
    emptyText = _ref.emptyText,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    tag = _ref.tag,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    excludeOptionValueFilter = _ref.excludeOptionValueFilter,
    filterCondition = _ref.filterCondition,
    autoFlipVertically = _ref.autoFlipVertically,
    customOption = _ref.customOption,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    selectionIndex = _useState4[0],
    setSelectionIndex = _useState4[1];
  var styles = useStyles$2(selectStyles$1, {});
  var options = Children.toArray(children);
  var _useFilteredOptions = useFilteredOptions(Children.toArray(children), filterCondition, excludeOptionValueFilter),
    _useFilteredOptions2 = _slicedToArray(_useFilteredOptions, 3),
    filteredOptions = _useFilteredOptions2[0],
    filterValue = _useFilteredOptions2[1],
    setFilterValue = _useFilteredOptions2[2];
  useEffect(function () {
    setSelectionIndex(-1);
  }, [isOpen, filterValue]);
  var selectedOption = customOption ? customOption : options.find(function (option) {
    return option.props.value === value;
  });
  var mappedValue = selectedOption ? selectedOption.props.children : null;
  var currentlySelectedOption = selectionIndex !== -1 ? options[selectionIndex] : null;
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(Stick, {
      sameWidth: true,
      style: styles('stick'),
      position: "bottom left",
      align: "top left",
      onClickOutside: function onClickOutside() {
        return setIsOpen(false);
      },
      node: isOpen ? /*#__PURE__*/React.createElement(Listbox, {
        ownerId: id
      }, filteredOptions.length === 0 && emptyText ? /*#__PURE__*/React.createElement(DisabledOption, null, /*#__PURE__*/React.createElement(Box$1, {
        paddingTop: "xsmall",
        paddingRight: "small",
        paddingBottom: "xsmall",
        paddingLeft: "small"
      }, emptyText)) : filteredOptions.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Option$1, _extends({}, option.props, {
          key: option.props.value,
          id: option.props.value,
          selected: value === option.props.value,
          disabled: !!option.props.disabled,
          icon: option.props.icon,
          tag: option.props.tag,
          hovered: index === selectionIndex,
          onMouseEnter: function onMouseEnter() {
            if (option.props.disabled) {
              return;
            }
            setSelectionIndex(index);
          },
          onSelect: function onSelect() {
            setIsOpen(false);
            if (onChange) {
              onChange(option.props.value);
            }
          }
        }), option);
      })) : null,
      autoFlipVertically: autoFlipVertically
    }, /*#__PURE__*/React.createElement(ComboInput$1, _extends({}, rest, {
      expanded: isOpen,
      readOnly: readOnly,
      clearable: clearable && value != null,
      required: required,
      disabled: disabled,
      error: error,
      hint: hint,
      icon: icon || (isOpen ? null : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.props.icon),
      id: id,
      tag: tag,
      title: mappedValue,
      placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
      value: mappedValue,
      activeDescendant: currentlySelectedOption ? currentlySelectedOption.props.value : null,
      onChange: function onChange(searchQuery) {
        if (onSearch) {
          onSearch(searchQuery);
        }
      },
      onSelectNext: function onSelectNext() {
        return setSelectionIndex(moveSelectionIndex(filteredOptions, selectionIndex, 1));
      },
      onSelectPrevious: function onSelectPrevious() {
        if (selectionIndex === -1) {
          setSelectionIndex(moveSelectionIndex(filteredOptions, filteredOptions.length, -1));
        } else {
          setSelectionIndex(moveSelectionIndex(filteredOptions, selectionIndex, -1));
        }
      },
      onSelectCurrent: function onSelectCurrent() {
        if (onChange && selectionIndex !== -1) {
          var _option = filteredOptions[selectionIndex];
          onChange(_option.props.value);
        }
        setIsOpen(false);
      },
      onToggleMenu: setIsOpen,
      onFilter: setFilterValue,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    })));
  });
}
var selectStyles$1 = function selectStyles(_ref2) {
  var zIndex = _ref2.zIndex;
  return {
    stick: {
      node: {
        zIndex: zIndex.dropdown
      }
    }
  };
};
function Option$1(_ref3) {
  var id = _ref3.id,
    children = _ref3.children,
    selected = _ref3.selected,
    hovered = _ref3.hovered,
    icon = _ref3.icon,
    tag = _ref3.tag,
    disabled = _ref3.disabled,
    onSelect = _ref3.onSelect,
    onMouseEnter = _ref3.onMouseEnter,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var styles = useStyles$2(optionStyles$1, {}, {
    '&selected': selected,
    '&hover': hovered
  });
  return /*#__PURE__*/React.createElement(Option$2, _extends({}, rest, {
    id: id,
    selected: selected,
    disabled: disabled,
    onSelect: onSelect,
    onMouseEnter: onMouseEnter
  }), /*#__PURE__*/React.createElement(Box$1, {
    style: styles,
    paddingTop: "xsmall",
    paddingRight: "small",
    paddingBottom: "xsmall",
    paddingLeft: "small"
  }, icon && /*#__PURE__*/React.createElement(Glyph, {
    style: styles('icon')
  }, icon), /*#__PURE__*/React.createElement("div", styles('content'), children), tag && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(InlineTag, {
    tagText: tag.tagText
  }))));
}
var optionStyles$1 = function optionStyles(_ref4) {
  var color = _ref4.color,
    spacing = _ref4.spacing;
  return {
    display: 'flex',
    content: {
      alignSelf: 'stretch',
      width: '100%'
    },
    icon: {
      color: color.text.inactive,
      marginRight: spacing.xxsmall
    },
    '&hover': {
      backgroundColor: color.hover.base
    },
    '&selected': {
      backgroundColor: color.active.primary,
      '&hover': {
        backgroundColor: color.activeHover.primary
      }
    }
  };
};
function SelectOption(_ref5) {
  var children = _ref5.children;
  return children;
}
Select.Option = SelectOption;var onSurface = Color('#000000');
var onContrast = Color('#FFFFFF');
var themePrimary = Color('#AD0F5B');
var themeSecondary = Color('#01737A');
var themeDanger = Color('#C12028');
var background = '#F2F2F2';
var surface = '#FFFFFF';
var contrast = '#242424';
var primary = {
  base: themePrimary.hex(),
  dark: themePrimary.darken(0.3).hex(),
  // deprecated
  light: themePrimary.alpha(0.12).string(),
  // deprecated
  lighter: themePrimary.alpha(0.08).string() // deprecated
};
var secondary = {
  base: themeSecondary.hex(),
  dark: themeSecondary.darken(0.3).hex(),
  // deprecated
  light: themeSecondary.alpha(0.12).string(),
  // deprecated
  lighter: themeSecondary.alpha(0.08).string() // deprecated
};
var danger = {
  base: themeDanger.hex(),
  dark: themeDanger.darken(0.25).hex(),
  // deprecated
  light: themeDanger.alpha(0.12).string(),
  // deprecated
  lighter: themeDanger.alpha(0.08).string() // deprecated
};

// Text & Icon
var text = {
  base: onSurface.alpha(0.9).string(),
  inactive: onSurface.alpha(0.64).string(),
  disabled: onSurface.alpha(0.42).string()
};
var contrastText = {
  base: onContrast.string(),
  inactive: onContrast.alpha(0.8).string(),
  disabled: onContrast.alpha(0.56).string()
};
var coloredText = {
  primary: primary.base,
  secondary: secondary.base,
  danger: danger.base
};

// Tints
var shading = {
  onLight: onSurface.alpha(0.04).string(),
  onDark: onContrast.alpha(0.08).string()
};
var divider = {
  base: onSurface.alpha(0.16).string(),
  contrast: onContrast.alpha(0.24).string()
};
var hover = {
  base: onSurface.alpha(0.08).string(),
  contrast: onContrast.alpha(0.12).string()
};
var active = {
  primary: primary.lighter,
  secondary: secondary.lighter,
  danger: danger.lighter,
  contrast: onContrast.alpha(0.42).string()
};
var activeHover = {
  primary: primary.light,
  secondary: secondary.light,
  danger: danger.light,
  contrast: onContrast.alpha(0.33).string()
};

// Status
// Status
var status = {
  info: '#0a6ed1',
  success: '#107e3e',
  warning: '#b3590a',
  danger: danger.base,
  light: {
    info: '#f5faff',
    success: '#f1fdf6',
    warning: '#fef7f1',
    danger: '#ffebeb'
  }
};
var extended11 = '#fb8824';
var extended12 = '#d1711e';
var extended21 = '#ffb300';
var extended22 = '#cc8f00';
var extended31 = '#359100';
var extended32 = '#276b00';
var extended41 = '#0f9660';
var extended42 = '#0b6e46';
var extended51 = '#0092b7';
var extended52 = '#006a85';
var extended61 = '#4a6ae5';
var extended62 = '#3c51b0';
var extended71 = '#9150f2';
var extended72 = '#6f3dba';
var extended81 = '#d13dc5';
var extended82 = '#a12f97';
var extended91 = '#db427d';
var extended92 = '#a6325e';

// Chart Palette Colors
var chartPrimary = Color('#11bdc0');
var chartSecondary = Color('#a1c265');
var chartTertiary = Color('#e3b264');
var chart1 = {
  base: chartPrimary.hex(),
  min: '#afdada',
  max: chartPrimary.darken(0.32).saturate(0.16).hex()
};
var chart2 = {
  base: chartSecondary.hex(),
  min: chartSecondary.lighten(0.32).desaturate(0.24).hex(),
  max: chartSecondary.darken(0.32).saturate(0.16).hex()
};
var chart3 = {
  base: chartTertiary.hex(),
  min: chartTertiary.lighten(0.32).desaturate(0.24).hex(),
  max: chartTertiary.darken(0.32).saturate(0.16).hex()
};
var chart4 = {
  base: '#79b8d1'
};
var chart5 = {
  base: '#c58dd9'
};
var chart6 = {
  base: '#7cc492'
};
var chart7 = {
  base: '#d68dad'
};
var chart8 = {
  base: '#deca5b'
};
var chart9 = {
  base: '#8ba7e8'
};
var chart10 = {
  base: '#e3a581'
};
var chart11 = {
  base: '#a49be8'
};
var chartMono = {
  base: '#808080',
  min: '#ddd',
  max: '#555'
};

// Content Type Colors
var externalLink = extended61;
var dictionaryItem = extended91;
var diagram = extended71;
var system = text.inactive;
var risk = extended11;
var control = extended31;
var folder = extended21;
var header$1 = {}; // deprecated

var mono = {
  ultradark: '#333',
  // deprecated
  dark: '#555',
  // deprecated
  middle: '#7f7f7f',
  // deprecated
  lighter: '#ccc',
  // deprecated
  light: '#ddd',
  // deprecated
  ultralight: '#eee' // deprecated
};var color=/*#__PURE__*/Object.freeze({__proto__:null,onSurface:onSurface,onContrast:onContrast,themePrimary:themePrimary,themeSecondary:themeSecondary,themeDanger:themeDanger,background:background,surface:surface,contrast:contrast,primary:primary,secondary:secondary,danger:danger,text:text,contrastText:contrastText,coloredText:coloredText,shading:shading,divider:divider,hover:hover,active:active,activeHover:activeHover,status:status,extended11:extended11,extended12:extended12,extended21:extended21,extended22:extended22,extended31:extended31,extended32:extended32,extended41:extended41,extended42:extended42,extended51:extended51,extended52:extended52,extended61:extended61,extended62:extended62,extended71:extended71,extended72:extended72,extended81:extended81,extended82:extended82,extended91:extended91,extended92:extended92,chartPrimary:chartPrimary,chartSecondary:chartSecondary,chartTertiary:chartTertiary,chart1:chart1,chart2:chart2,chart3:chart3,chart4:chart4,chart5:chart5,chart6:chart6,chart7:chart7,chart8:chart8,chart9:chart9,chart10:chart10,chart11:chart11,chartMono:chartMono,externalLink:externalLink,dictionaryItem:dictionaryItem,diagram:diagram,system:system,risk:risk,control:control,folder:folder,header:header$1,mono:mono});var logo = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="88px" height="40px" viewBox="0 0 88 40"><path fill="#fff" d="M39.57,16.1c-0.39,0-0.7,0.3-0.7,0.65v8.57c0,0.2,0.2,0.64,0.7,0.64c0.5,0,0.7-0.43,0.7-0.64v-8.57C40.28,16.53,40.06,16.1,39.57,16.1zM46.07,26c1.37,0,2.55-0.4,2.63-0.45c0.1-0.05,0.3-0.19,0.38-0.3c0.08-0.1,0.14-0.25,0.14-0.44v-3.45c0-0.3-0.14-0.47-0.27-0.58c-0.1-0.1-0.34-0.23-0.6-0.2h-2.07c-0.3,0-0.69,0.2-0.69,0.63c0,0.34,0.29,0.6,0.69,0.6h1.53v2.7c-0.5,0.15-1,0.24-1.7,0.24c-1.33,0-2.37-0.66-2.37-2.09v-3.23c0-1.45,1.05-2.09,2.37-2.09c0.77,0,1.43,0.35,1.76,0.47c0.18,0.07,0.73,0.15,0.93-0.3c0.19-0.43-0.15-0.74-0.28-0.8c-0.63-0.33-1.54-0.59-2.4-0.59c-2.24,0-3.78,1.3-3.78,3.36v3.15C42.29,24.4,43.57,26,46.07,26zM83.86,16.1c-2.08,0-3.58,1.24-3.58,3.19v3.49c0,2.09,1.67,3.19,3.59,3.19c2.29,0,3.58-1.44,3.58-3.19V19.3C87.45,17.55,86.15,16.1,83.86,16.1zM86.04,22.83c0,1.08-0.7,1.9-2.17,1.9c-1.3,0-2.17-0.7-2.17-1.9v-3.56c0-1.26,0.9-1.94,2.17-1.94c1.34,0,2.17,0.73,2.17,1.94V22.83zM33.77,24.75c-0.69,0-1.35-0.23-2-0.57c-0.18-0.1-0.66-0.15-0.86,0.19c-0.24,0.39,0,0.76,0.27,0.93c0.48,0.29,1.66,0.68,2.6,0.68c2.4,0,3.28-1.69,3.28-2.68c0-1.95-1.5-2.6-3.08-3.24c-0.8-0.3-1.8-0.58-1.8-1.5c0-0.86,0.87-1.23,1.8-1.23c0.64,0,1.47,0.3,1.89,0.44c0.29,0.09,0.73,0,0.85-0.34c0.1-0.3,0-0.64-0.44-0.83c-0.65-0.27-1.55-0.48-2.23-0.48c-1.4,0-3.3,0.65-3.3,2.4c0,0.79,0.3,1.49,1,2c0.68,0.46,1.69,0.77,2,0.9c1.18,0.5,1.93,0.84,1.84,1.89C35.56,24.1,34.75,24.75,33.77,24.75zM74.87,16.14c-0.3-0.09-0.7-0-0.87,0.4c-0,0.1-2.56,7.1-2.56,7.1s-2.55-7.06-2.59-7.16c-0.13-0.3-0.4-0.47-0.84-0.37c-0.46,0.13-0.54,0.56-0.48,0.74c0.04,0.1,3.1,8.48,3.15,8.59c0.1,0.3,0.38,0.5,0.75,0.5c0.5,0,0.7-0.35,0.75-0.49c0.04-0.1,3.1-8.46,3.13-8.53C75.44,16.57,75.2,16.24,74.87,16.14zM67.68,25.6c0.07-0.13,0.1-0.3,0.04-0.47c-0.06-0.15-3.2-8.39-3.29-8.58c-0.1-0.3-0.46-0.46-0.74-0.46c-0.26,0-0.6,0.15-0.74,0.46c-0.08,0.2-3.2,8.4-3.29,8.58c-0.13,0.35,0.14,0.6,0.19,0.65c0.17,0.13,0.33,0.17,0.47,0.17c0.3,0,0.56-0.19,0.65-0.4c0.04-0.1,0.87-2.27,0.87-2.27h3.7c0,0,0.8,2.14,0.86,2.24c0.1,0.3,0.38,0.45,0.66,0.45C67.34,26,67.57,25.8,67.68,25.6zM62.3,22.04l1.38-3.67l1.38,3.67H62.3zM77.56,16.1c-0.38,0-0.7,0.3-0.7,0.65v8.57c0,0.2,0.2,0.64,0.7,0.64c0.5,0,0.7-0.43,0.7-0.64v-8.57C78.26,16.53,78.05,16.1,77.56,16.1zM58.2,25.25v-8.49c0-0.39-0.37-0.65-0.7-0.65c-0.35,0-0.7,0.26-0.7,0.65v6.36c0,0-4.04-6.58-4.08-6.65c-0.14-0.23-0.38-0.36-0.69-0.36c-0.4,0-0.78,0.3-0.78,0.7v8.5c0,0.35,0.33,0.64,0.7,0.64c0.4,0,0.7-0.3,0.7-0.64v-6.36c0,0,4,6.55,4.08,6.63c0.1,0.19,0.34,0.36,0.69,0.36C57.85,26,58.2,25.7,58.2,25.25z"/><path fill="#fff" d="M25.26,19.37c-0.09-0.16-0.28-0.3-0.5-0.3c-0.1-0-1.1-0.06-2-0.08c-0.2-0-0.73-0-1-0c-0.05,0-0.09,0-0.1-0c-0-0-0.06-0.04-0.08-0.09c-0.09-0.27-0.27-0.88-0.5-1.3c-0.2-0.39-0.47-0.74-0.66-1.1c-0.19-0.37-0.35-0.65-0.37-0.77c-0-0.1,0.83,0.27,0.9,0.3c0.07,0,0.29,0.1,0.4,0.1c0.1,0,0.2-0,0.4-0.2c0.25-0.2,0.28-0.46,0.26-0.68c-0-0.16-0.18-0.39-0.33-0.6c-0.15-0.2-0.3-0.43-0.37-0.63c-0.16-0.45-0.26-0.9-0.57-1.5c-0.2-0.4-0.73-0.7-1-0.85c-0.44-0.23-0.86-0.36-0.86-0.36c-0.48-2.08-1.19-2.96-3-3.47c-1.65-0.47-2.5-0.73-3.24-1.4c-0.1-0.1-0.23-0.14-0.3-0.09c-0.1,0.06-0.09,0.18-0,0.29c0.43,0.83,1.56,1.5,3.1,2.07c1.15,0.4,1.79,1.08,1.93,2.08c-0.3,0-0.69-0.18-0.77-0.2c-0.1-0-0.17-0-0.2,0c-0,0-0.06,0.06-0.04,0.16c0,0.1,0.13,0.6,0.35,1.05c0.23,0.43,0.29,0.54,0.37,0.66c-0.05,0.29-0.2,1.45-0.19,2.53c0,1.08-0,2.73-0.09,3c0,0-0.17,0.16-0.57,0.5c-0.4,0.35-2.69,2-3.66,2.6c-0.84,0.5-3.36,1.94-5.3,2.47c-0.77,0.2-0.89,0.2-0.9,0.34c-0,0.07,0.04,0.13,0.17,0.19c0.17,0.06,1.17,0.43,1.16,0.6c-0,0.48-0.44,1-0.7,1.76c-0.13,0.45-0.6,0.84-1.07,1.14c-0.24,0.15-0.47,0.28-0.66,0.38c-0.2,0.1-0.33,0.17-0.44,0.3c-0.2,0.3-0.27,0.67-0.66,1.06c-0.44,0.44-0.88,0.94-1.2,1.28c-0.37,0.39-0.78,1.29-1.07,1.56c-0.13,0.14-0.33,0.24-0.45,0.28c-0.1,0.04-0.38,0.08-0.43,0.24c-0.05,0.16-0.19,0.46-0.1,0.84c0.05,0.2,0.2,0.26,0.36,0.27c0.1,0,0.17-0.04,0.24-0.08c0.08-0.05,0.6-0.44,1.06-0.94c1.05-1.19,2.17-2.8,3.04-3.45c0.9-0.67,3.5-1.58,4.67-2.33c0.58-0.38,1.2-1,1.73-1.49c0.26-0.25,0.48-0.49,0.65-0.66c0.09-0.08,0.16-0.15,0.2-0.2c0-0,0.04-0,0.05-0.05c0.35-0.05,2.96-0.16,5.39-1c1.1-0.38,1.8-1,2.3-1.56c0.37-0.4,0.85-1.17,0.94-1.2c0.05-0,0.28-0.07,0.34-0.08c0.57-0.1,1.05-0.1,1.44-0.1c0.08,0,0.1,0,0.14,0c0,0-0.5,0.76-0.7,1c-0.2,0.27-0.5,0.5-0.74,0.66c-0.2,0.16-0.48,0.27-0.6,0.5c-0.13,0.24-0.33,0.5-0.78,0.7c-0.68,0.3-0.8,0.5-0.77,0.7c0,0.2,0.2,0.7,0.4,0.7c0.13,0,0.34-0.1,0.57-0.24c0.66-0.4,2.25-1.9,2.86-2.54c0.6-0.6,1.4-1.8,1.7-2.26C25.35,19.8,25.35,19.54,25.26,19.37z"/></svg>';
var logo$1 = logo;var lineHeight = 1.5;
var name = 'default';var defaultSignavioTheme=/*#__PURE__*/Object.freeze({__proto__:null,color:color,lineHeight:lineHeight,name:name,padding:padding,spacing:spacing$1,font:font,size:size,zIndex:zIndex,shadow:shadow$1,border:border,logo:logo$1});var ESCAPE = 27;var xxxsmall = 4;
var xxsmall = 8;
var xsmall = 12;
var small = 16;
var medium = 20;
var large = 24;
var xlarge = 32;
var xxlarge = 48;
var xxxlarge = 72;
var xxxxlarge = 88;var spacing=/*#__PURE__*/Object.freeze({__proto__:null,xxxsmall:xxxsmall,xxsmall:xxsmall,xsmall:xsmall,small:small,medium:medium,large:large,xlarge:xlarge,xxlarge:xxlarge,xxxlarge:xxxlarge,xxxxlarge:xxxxlarge});var ThemeContext = /*#__PURE__*/createContext(defaultSignavioTheme);
var FioriStylesFlagContext = /*#__PURE__*/createContext(false);function useFioriStyles() {
  return useContext(FioriStylesFlagContext);
}function useTheme() {
  return useContext(ThemeContext);
}function useBaseColor() {
  var fioriStyles = useFioriStyles();
  var _useTheme = useTheme(),
    color = _useTheme.color;
  return fioriStyles ? color.primary.base : color.secondary.base;
}var useStyles = function useStyles(defaultStyle, styleProps, modifiers) {
  var theme = useTheme();
  var resolvedDefaultStyle = useMemo(function () {
    return typeof defaultStyle === 'function' ? defaultStyle(theme) : defaultStyle;
  }, [defaultStyle, theme]);
  return useStyles$3(resolvedDefaultStyle, styleProps, modifiers);
};
var useStyles$1 = useStyles;var _excluded$e = ["id", "children", "disabled", "readOnly", "value", "placeholder", "label", "labelPosition", "error", "icon", "required", "onChange", "onSearch", "description", "hint", "emptyText", "clearable", "readOnlyPlaceholder", "filterCondition", "autoFlipVertically"];
function MultiSelect(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    value = _ref.value,
    placeholder = _ref.placeholder,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    error = _ref.error,
    icon = _ref.icon,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    description = _ref.description,
    hint = _ref.hint,
    emptyText = _ref.emptyText,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    filterCondition = _ref.filterCondition,
    autoFlipVertically = _ref.autoFlipVertically,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  var inputRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    selectionIndex = _useState4[0],
    setSelectionIndex = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    newSelectedOptions = _useState6[0],
    setNewSelectedOptions = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    newDeselectedOptions = _useState8[0],
    setNewDeselectedOptions = _useState8[1];
  var styles = useStyles$2(selectStyles, {});
  var _useFilteredOptions = useFilteredOptions(Children.toArray(children), filterCondition),
    _useFilteredOptions2 = _slicedToArray(_useFilteredOptions, 3),
    options = _useFilteredOptions2[0],
    filterValue = _useFilteredOptions2[1],
    setFilterValue = _useFilteredOptions2[2];
  var _useGroupedOptions = useGroupedOptions(options, value, {
      includeInSelected: newDeselectedOptions,
      excludeFromSelected: newSelectedOptions
    }),
    _useGroupedOptions2 = _slicedToArray(_useGroupedOptions, 2),
    selectedOptions = _useGroupedOptions2[0],
    deselectedOptions = _useGroupedOptions2[1];
  useEffect(function () {
    setNewSelectedOptions([]);
    setNewDeselectedOptions([]);
  }, [isOpen]);
  useEffect(function () {
    setSelectionIndex(-1);
  }, [isOpen, filterValue]);
  var mappedValue = selectedOptions.map(function (option) {
    return option.props.children;
  }).join(', ');
  var handleSelect = function handleSelect(newValue) {
    if (!onChange) {
      return;
    }
    if (value.includes(newValue)) {
      onChange(value.filter(function (existingValue) {
        return existingValue !== newValue;
      }));
      if (newSelectedOptions.includes(newValue)) {
        setNewSelectedOptions(newSelectedOptions.filter(function (value) {
          return value !== newValue;
        }));
      } else {
        setNewDeselectedOptions([].concat(_toConsumableArray(newDeselectedOptions), [newValue]));
      }
    } else {
      onChange([].concat(_toConsumableArray(value), [newValue]));
      if (newDeselectedOptions.includes(newValue)) {
        setNewDeselectedOptions(newDeselectedOptions.filter(function (value) {
          return value !== newValue;
        }));
      } else {
        setNewSelectedOptions([].concat(_toConsumableArray(newSelectedOptions), [newValue]));
      }
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  var sortedOptions = [].concat(_toConsumableArray(selectedOptions), _toConsumableArray(deselectedOptions));
  var currentlySelectedOption = selectionIndex !== -1 ? sortedOptions[selectionIndex] : null;
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(Stick, {
      sameWidth: true,
      style: styles('stick'),
      position: "bottom left",
      align: "top left",
      onClickOutside: function onClickOutside() {
        return setIsOpen(false);
      },
      autoFlipVertically: autoFlipVertically,
      node: isOpen ? /*#__PURE__*/React.createElement(Listbox, {
        enableMultiSelect: true,
        ownerId: id
      }, selectedOptions.length === 0 && deselectedOptions.length === 0 ? /*#__PURE__*/React.createElement(DisabledOption, null, /*#__PURE__*/React.createElement(Box$1, {
        paddingTop: "xsmall",
        paddingRight: "small",
        paddingBottom: "xsmall",
        paddingLeft: "small"
      }, emptyText)) : /*#__PURE__*/React.createElement(React.Fragment, null, selectedOptions.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Option, {
          id: option.props.value,
          key: option.props.value,
          active: !newDeselectedOptions.includes(option.props.value),
          hovered: index === selectionIndex,
          icon: option.props.icon,
          disabled: !!option.props.disabled,
          onMouseEnter: function onMouseEnter() {
            if (option.props.disabled) {
              return;
            }
            setSelectionIndex(index);
          },
          onSelect: function onSelect() {
            return handleSelect(option.props.value);
          }
        }, option);
      }), deselectedOptions.length > 0 && selectedOptions.length > 0 && /*#__PURE__*/React.createElement(Divider, null), deselectedOptions.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Option, {
          id: option.props.value,
          key: option.props.value,
          icon: option.props.icon,
          disabled: !!option.props.disabled,
          active: newSelectedOptions.includes(option.props.value),
          hovered: index + selectedOptions.length === selectionIndex,
          onMouseEnter: function onMouseEnter() {
            if (option.props.disabled) {
              return;
            }
            setSelectionIndex(selectedOptions.length + index);
          },
          onSelect: function onSelect() {
            return handleSelect(option.props.value);
          }
        }, option);
      }))) : null
    }, /*#__PURE__*/React.createElement(ComboInput$1, _extends({}, rest, {
      keepFilterValue: false,
      ref: inputRef,
      expanded: isOpen,
      readOnly: readOnly,
      clearable: clearable && value.length !== 0,
      required: required,
      disabled: disabled,
      error: error,
      hint: hint,
      icon: icon,
      id: id,
      title: mappedValue,
      placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
      value: mappedValue,
      activeDescendant: currentlySelectedOption ? currentlySelectedOption.props.value : null,
      onChange: function onChange(searchQuery) {
        if (onSearch) {
          onSearch(searchQuery);
        }
      },
      onSelectNext: function onSelectNext() {
        return setSelectionIndex(moveSelectionIndex(sortedOptions, selectionIndex, 1));
      },
      onSelectPrevious: function onSelectPrevious() {
        if (selectionIndex === -1) {
          setSelectionIndex(moveSelectionIndex(sortedOptions, sortedOptions.length, -1));
        } else {
          setSelectionIndex(moveSelectionIndex(sortedOptions, selectionIndex, -1));
        }
      },
      onSelectCurrent: function onSelectCurrent() {
        if (onChange && selectionIndex !== -1) {
          var _option = sortedOptions[selectionIndex];
          handleSelect(_option.props.value);
        }
      },
      onToggleMenu: setIsOpen,
      onFilter: setFilterValue,
      onClear: function onClear() {
        if (onChange) {
          onChange([]);
        }
      }
    })));
  });
}
var selectStyles = function selectStyles(_ref2) {
  var zIndex = _ref2.zIndex;
  return {
    stick: {
      node: {
        zIndex: zIndex.dropdown
      }
    }
  };
};
var useGroupedOptions = function useGroupedOptions(options, selectedOptions, _ref3) {
  var excludeFromSelected = _ref3.excludeFromSelected,
    includeInSelected = _ref3.includeInSelected;
  return options.reduce(function (_ref4, option) {
    var _ref5 = _slicedToArray(_ref4, 2),
      selected = _ref5[0],
      deselected = _ref5[1];
    if (selectedOptions.includes(option.props.value) && !excludeFromSelected.includes(option.props.value) || includeInSelected.includes(option.props.value)) {
      return [[].concat(_toConsumableArray(selected), [option]), deselected];
    }
    return [selected, [].concat(_toConsumableArray(deselected), [option])];
  }, [[], []]);
};
function Option(_ref6) {
  var id = _ref6.id,
    children = _ref6.children,
    active = _ref6.active,
    hovered = _ref6.hovered,
    icon = _ref6.icon,
    disabled = _ref6.disabled,
    onSelect = _ref6.onSelect,
    onMouseEnter = _ref6.onMouseEnter;
  var baseColor = useBaseColor();
  var styles = useStyles$2(optionStyles, {}, {
    '&active': active,
    '&hover': hovered,
    checkbox: {
      color: baseColor
    }
  });
  return /*#__PURE__*/React.createElement(Option$2, {
    id: id,
    selected: active,
    disabled: disabled,
    onMouseEnter: onMouseEnter,
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: styles,
    paddingTop: "xsmall",
    paddingRight: "small",
    paddingBottom: "xsmall",
    paddingLeft: "small"
  }, /*#__PURE__*/React.createElement(Stack$1, {
    direction: "horizontal",
    spacing: "small"
  }, /*#__PURE__*/React.createElement(Glyph, {
    style: styles('checkbox')
  }, active ? 'checkbox-true' : 'checkbox-false'), /*#__PURE__*/React.createElement(Stack$1, {
    direction: "horizontal",
    spacing: "xxsmall"
  }, icon && /*#__PURE__*/React.createElement(Glyph, {
    style: styles('icon')
  }, icon), children))));
}
var optionStyles = function optionStyles(_ref7) {
  var color = _ref7.color;
  return {
    icon: {
      color: color.text.inactive
    },
    '&hover': {
      backgroundColor: color.hover.base
    },
    '&active': {
      backgroundColor: color.active.secondary,
      '&hover': {
        backgroundColor: color.activeHover.secondary
      }
    }
  };
};
function MultiSelectOption(_ref8) {
  var children = _ref8.children;
  return children;
}
MultiSelect.Option = MultiSelectOption;var _excluded$d = ["id", "hint", "icon", "onChange", "labelPosition", "description", "label", "tabIndex", "required", "onBlur", "locale", "placeholder", "onFocus", "error", "value", "children", "currenciesLabel", "controls", "disabled", "readOnly", "clearable", "readOnlyPlaceholder"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CurrencyInput(_ref) {
  var _value$amount;
  var id = _ref.id,
    hint = _ref.hint,
    icon = _ref.icon,
    _onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    tabIndex = _ref.tabIndex,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? navigator.language : _ref$locale,
    placeholder = _ref.placeholder,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    value = _ref.value,
    children = _ref.children,
    currenciesLabel = _ref.currenciesLabel,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$d);
  var style = useStyles$2(defaultStyles$g, {}, {
    '&isLabelTop': labelPosition === 'top'
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    temporaryValue = _useState4[0],
    setTemporaryValue = _useState4[1];
  var currency = value.currency;
  var amount = (_value$amount = value.amount) !== null && _value$amount !== void 0 ? _value$amount : null;
  var currencyFormatter = useMemo(function () {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    });
  }, [currency, locale]);
  var numberFormatter = useMemo(function () {
    var _currencyFormatter$re = currencyFormatter.resolvedOptions(),
      maximumFractionDigits = _currencyFormatter$re.maximumFractionDigits,
      minimumFractionDigits = _currencyFormatter$re.minimumFractionDigits;
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: minimumFractionDigits,
      useGrouping: false
    });
  }, [currencyFormatter, locale]);
  useEffect(function () {
    if (!focussed) {
      setTemporaryValue(null);
    }
  }, [focussed, amount]);
  useEffect(function () {
    if (focussed && amount != null) {
      setTemporaryValue(numberFormatter.format(amount));
    }
  }, [amount, focussed, numberFormatter]);
  useEffect(function () {
    if (amount == null) {
      setTemporaryValue(null);
    }
  }, [amount]);
  var formattedAmount = amount != null ? currencyFormatter.format(amount) : null;
  var currencies = Children.toArray(children);
  var currencySymbol = useMemo(function () {
    return currencyFormatter.format(0).replace(/[\d\s.,]+/, '');
  }, [currencyFormatter]);
  var selectedCurrency = currencies.find(function (option) {
    return option.props.value === value.currency;
  });
  var inputRef = useRef(null);
  var caretPositionRef = useRef(null);
  useLayoutEffect(function () {
    if (caretPositionRef.current !== null && inputRef.current) {
      inputRef.current.setSelectionRange(caretPositionRef.current, caretPositionRef.current);
    }
  }, [temporaryValue]);
  invariant(selectedCurrency, "The currency \"".concat(value.currency, "\" could not be found in possible currencies for this input. Possible options are \"").concat(currencies.map(function (_ref2) {
    var props = _ref2.props;
    return props.value;
  }).join('", "'), "\"."));
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement("div", style('flexContainer'), /*#__PURE__*/React.createElement(InputContainer, {
      controls: controls,
      htmlFor: id,
      clearable: clearable && value.amount != null,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear(event) {
        if (_onChange) {
          _onChange(_objectSpread$6(_objectSpread$6({}, value), {}, {
            amount: null
          }));
        }
      }
    }, function (internalRef, styles) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput$2, _extends({}, rest, {
        "aria-describedby": descriptionId(id),
        "aria-invalid": !!error,
        style: styles,
        ref: mergeRefs([internalRef, inputRef]),
        id: id,
        required: required,
        tabIndex: tabIndex,
        inputMode: "numeric",
        value: temporaryValue || formattedAmount,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder || currencySymbol : placeholder || currencySymbol,
        onChange: function onChange(newValue, event) {
          // prevent cursor from jumping when entering an invalid value
          // caret position is saved in a ref and restored after the value has been sanitized
          caretPositionRef.current = event.target.selectionStart;
          var strippedValue = sanitizeNumberInput(newValue);
          setTemporaryValue(strippedValue);
          var newAmount = parseNumberString(locale, strippedValue);
          if (amount === newAmount) {
            return;
          }
          if (_onChange) {
            _onChange(_objectSpread$6(_objectSpread$6({}, value), {}, {
              amount: newAmount
            }), event);
          }
        },
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly
      })), (currencies.length === 1 || readOnly) && /*#__PURE__*/React.createElement("div", style('currencyTag'), /*#__PURE__*/React.createElement(Popover, {
        popover: selectedCurrency.props.children,
        position: "bottom"
      }, /*#__PURE__*/React.createElement("div", style('flexContainer'), /*#__PURE__*/React.createElement(Tag, {
        small: true
      }, currency)))));
    }), !readOnly && currencies.length > 1 && /*#__PURE__*/React.createElement("div", style('currenciesContainer'), /*#__PURE__*/React.createElement(Box$1, {
      marginLeft: "xxxsmall"
    }, /*#__PURE__*/React.createElement(CurrencySelect, {
      disabled: disabled,
      readOnly: readOnly,
      currency: currency,
      tabIndex: tabIndex,
      label: currenciesLabel,
      onChange: function onChange(newCurrency) {
        if (!_onChange || !newCurrency) {
          return;
        }
        _onChange(_objectSpread$6(_objectSpread$6({}, value), {}, {
          currency: newCurrency
        }));
      }
    }, children))));
  });
}
var defaultStyles$g = function defaultStyles(_ref3) {
  var spacing = _ref3.spacing;
  return {
    currencyTag: {
      paddingRight: spacing.xxsmall
    },
    flexContainer: {
      display: 'flex'
    },
    currenciesContainer: {
      width: '50%'
    },
    '&isLabelTop': {
      currenciesContainer: {
        width: '40%'
      }
    }
  };
};
function CurrencySelect(_ref4) {
  var disabled = _ref4.disabled,
    readOnly = _ref4.readOnly,
    currency = _ref4.currency,
    tabIndex = _ref4.tabIndex,
    children = _ref4.children,
    label = _ref4.label,
    onChange = _ref4.onChange;
  invariant(label, 'You need to specify an accessible label for the currencies select');
  return /*#__PURE__*/React.createElement(Select, {
    required: true,
    "aria-label": label,
    clearable: false,
    label: null,
    tabIndex: tabIndex,
    disabled: disabled,
    readOnly: readOnly,
    value: currency,
    onChange: onChange
  }, children);
}
CurrencyInput.Currency = Select.Option;var _excluded$c = ["id", "description", "label", "labelPosition", "placeholder", "required", "value", "error", "hint", "addItemOnBlur", "onChange", "icon", "locale", "onKeyDown", "disabled", "readOnly", "clearable", "onFocus", "minDate", "maxDate", "controls", "readOnlyPlaceholder"];
function DateInput(_ref, ref) {
  var id = _ref.id,
    description = _ref.description,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    error = _ref.error,
    hint = _ref.hint,
    addItemOnBlur = _ref.addItemOnBlur,
    _onChange = _ref.onChange,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'date' : _ref$icon,
    locale = _ref.locale,
    _onKeyDown = _ref.onKeyDown,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    _onFocus = _ref.onFocus,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  var dateInput = useRef();
  var styles = useStyles$2(defaultStyles$f, {});
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var theme = useTheme$1();
  useEffect(function () {
    if (!dateInput.current) {
      return;
    }
    if (isOpen) {
      dateInput.current.focus();
    } else {
      dateInput.current.blur();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(Stick, {
      position: "bottom left",
      align: "top left",
      style: styles('stick'),
      onClickOutside: function onClickOutside() {
        return setIsOpen(false);
      },
      node: isOpen ? /*#__PURE__*/React.createElement(Box$1, {
        shadow: "menu",
        style: theme.border.hint
      }, /*#__PURE__*/React.createElement(DatePicker, {
        minDate: minDate,
        maxDate: maxDate,
        locale: locale,
        disabled: disabled,
        value: value,
        autofocus: false,
        onChange: function onChange(newDate) {
          setIsOpen(false);
          if (_onChange && !addItemOnBlur) {
            _onChange(newDate);
          }
          if (addItemOnBlur) {
            addItemOnBlur(newDate);
          }
        }
      })) : null
    }, /*#__PURE__*/React.createElement(InputContainer, {
      controls: /*#__PURE__*/React.createElement(React.Fragment, null, !readOnly && /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": isOpen ? 'Close select' : 'Open select',
        disabled: disabled,
        icon: isOpen ? 'dropdown-close' : 'dropdown-open',
        onClick: function onClick() {
          return setIsOpen(!isOpen);
        },
        tabIndex: -1
      }), controls),
      htmlFor: id,
      clearable: isOpen ? false : clearable && value != null,
      error: isOpen ? null : error,
      icon: icon,
      hint: isOpen ? null : hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: isOpen,
      onClear: function onClear() {
        if (_onChange) {
          _onChange(null);
        }
      }
    }, function (inputRef, styles) {
      return /*#__PURE__*/React.createElement(Date$1, _extends({}, rest, {
        id: id,
        "aria-describedby": descriptionId(id),
        "aria-invalid": error != null,
        ref: mergeRefs([dateInput, inputRef, ref]),
        style: styles,
        value: value,
        onChange: _onChange,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        disabled: disabled || readOnly,
        required: required,
        culture: locale,
        onFocus: function onFocus(event) {
          if (!isOpen) {
            if (_onFocus) {
              _onFocus(event);
            }
            setIsOpen(true);
          }
        },
        onKeyDown: function onKeyDown(event, _ref2) {
          var isFirst = _ref2.isFirst,
            isLast = _ref2.isLast;
          if (_onKeyDown) {
            _onKeyDown(event);
          }
          if (event.key !== 'Tab') {
            return;
          }
          if (event.shiftKey) {
            setIsOpen(!isFirst);
          } else {
            setIsOpen(!isLast);
          }
        }
      }));
    }));
  });
}
var defaultStyles$f = function defaultStyles(_ref3) {
  var color = _ref3.color;
    _ref3.spacing;
    var zIndex = _ref3.zIndex;
  return {
    menu: {
      backgroundColor: color.surface
    },
    stick: {
      node: {
        zIndex: zIndex.dropdown
      }
    }
  };
};
var DateInput$1 = /*#__PURE__*/forwardRef(DateInput);var _excluded$b = ["id", "clearable", "description", "disabled", "icon", "error", "hint", "label", "labelPosition", "onChange", "onKeyDown", "readOnly", "required", "value", "locale", "onFocus", "controls", "readOnlyPlaceholder", "placeholder", "minDate", "maxDate"];
function DateTimeInput(_ref, ref) {
  var id = _ref.id,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    description = _ref.description,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'datetime' : _ref$icon,
    error = _ref.error,
    hint = _ref.hint,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    _onChange = _ref.onChange,
    _onKeyDown = _ref.onKeyDown,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    locale = _ref.locale,
    _onFocus = _ref.onFocus,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    placeholder = _ref.placeholder,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  var dateTimeInput = useRef();
  var theme = useTheme$1();
  var styles = useStyles$2(defaultStyles$e, {});
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    if (!dateTimeInput.current) {
      return;
    }
    if (isOpen) {
      dateTimeInput.current.focus();
    } else {
      dateTimeInput.current.blur();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(Stick, {
      position: "bottom left",
      align: "top left",
      style: styles('stick'),
      onClickOutside: function onClickOutside() {
        return setIsOpen(false);
      },
      node: isOpen ? /*#__PURE__*/React.createElement(Box$1, {
        shadow: "menu",
        style: theme.border.hint
      }, /*#__PURE__*/React.createElement(DatePicker, {
        "data-testid": "date-picker",
        minDate: minDate,
        maxDate: maxDate,
        locale: locale,
        disabled: disabled,
        value: transformToLocalDateOnly(value),
        autofocus: false,
        onChange: function onChange(newDate) {
          if (!_onChange) return;
          if (value) {
            var currentDate = new Date(value);
            var correctedDate = addMinutes(new Date(newDate), new Date(newDate).getTimezoneOffset());
            correctedDate.setHours(currentDate.getHours());
            correctedDate.setMinutes(currentDate.getMinutes());
            _onChange(correctedDate.toISOString());
          } else {
            _onChange(addMinutes(new Date(newDate), new Date(newDate).getTimezoneOffset()).toISOString());
          }
        }
      })) : null
    }, /*#__PURE__*/React.createElement(InputContainer, {
      clearable: clearable && value != null,
      controls: /*#__PURE__*/React.createElement(React.Fragment, null, !readOnly && /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": isOpen ? 'Close select' : 'Open select',
        disabled: disabled,
        icon: isOpen ? 'dropdown-close' : 'dropdown-open',
        onClick: function onClick() {
          return setIsOpen(!isOpen);
        },
        tabIndex: -1
      }), controls),
      disabled: disabled,
      error: error,
      focussed: isOpen,
      hint: hint,
      htmlFor: id,
      icon: icon,
      onClear: function onClear() {
        if (_onChange) {
          _onChange(null);
        }
      },
      readOnly: readOnly
    }, function (inputRef, styles) {
      return /*#__PURE__*/React.createElement(DateTime, _extends({}, rest, {
        "aria-describedby": descriptionId(id),
        "aria-invalid": error != null,
        culture: locale,
        disabled: disabled || readOnly,
        id: id,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: _onChange,
        onFocus: function onFocus(event) {
          if (!isOpen) {
            if (_onFocus) {
              _onFocus(event);
            }
            setIsOpen(true);
          }
        },
        onKeyDown: function onKeyDown(event, _ref2) {
          var isLast = _ref2.isLast,
            isFirst = _ref2.isFirst;
          if (_onKeyDown) {
            _onKeyDown(event);
          }
          if (event.key !== 'Tab') {
            return;
          }
          if (event.shiftKey) {
            setIsOpen(!isFirst);
          } else {
            setIsOpen(!isLast);
          }
        },
        ref: mergeRefs([dateTimeInput, inputRef, ref]),
        required: required,
        style: styles,
        value: value
      }));
    }));
  });
}
function transformToLocalDateOnly(utcValue) {
  if (!utcValue) {
    return null;
  }
  var localDateWithTime = new Date(utcValue);
  var twoDigitMonth = (localDateWithTime.getMonth() + 1).toString().padStart(2, '0');
  var twoDigitDay = localDateWithTime.getDate().toString().padStart(2, '0');
  var localDate = "".concat(localDateWithTime.getFullYear(), "-").concat(twoDigitMonth, "-").concat(twoDigitDay);
  return localDate;
}
var defaultStyles$e = function defaultStyles(_ref3) {
  _ref3.color;
    _ref3.spacing;
    var zIndex = _ref3.zIndex;
    _ref3.border;
  return {
    stick: {
      node: {
        zIndex: zIndex.dropdown
      }
    }
  };
};
var DateTimeInput$1 = /*#__PURE__*/forwardRef(DateTimeInput);var _excluded$a = ["id", "hint", "icon", "label", "labelPosition", "description", "required", "readOnly", "controls", "clearable", "value", "onBlur", "onFocus", "onChange", "error", "disabled", "placeholder", "readOnlyPlaceholder"];
function DurationInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'duration' : _ref$icon,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    value = _ref.value,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    placeholder = _ref.placeholder,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      controls: controls,
      htmlFor: id,
      clearable: clearable && value != null,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (inputRef, styles) {
      return /*#__PURE__*/React.createElement(DurationInput$2, _extends({}, rest, {
        style: styles,
        "aria-describedby": descriptionId(id),
        ref: mergeRefs([ref, inputRef]),
        id: id,
        value: value,
        required: required,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        onChange: onChange,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": !!error
      }));
    });
  });
}
var DurationInput$1 = /*#__PURE__*/forwardRef(DurationInput);var _excluded$9 = ["id", "hint", "icon", "onChange", "controls", "labelPosition", "description", "label", "required", "onBlur", "onFocus", "error", "disabled", "clearable", "value", "readOnly", "placeholder", "locale", "readOnlyPlaceholder"];
function TimeInput(_ref, ref) {
  var id = _ref.id,
    hint = _ref.hint,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'time' : _ref$icon,
    onChange = _ref.onChange,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    error = _ref.error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    value = _ref.value,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    placeholder = _ref.placeholder,
    locale = _ref.locale,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focussed = _useState2[0],
    setFocussed = _useState2[1];
  return /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: id,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(InputContainer, {
      htmlFor: id,
      controls: controls,
      clearable: clearable && value != null,
      error: error,
      icon: icon,
      hint: hint,
      disabled: disabled,
      readOnly: readOnly,
      focussed: focussed,
      onClear: function onClear() {
        if (onChange) {
          onChange(null);
        }
      }
    }, function (internalRef, styles) {
      return /*#__PURE__*/React.createElement(Time, _extends({}, rest, {
        style: styles,
        "aria-describedby": descriptionId(id),
        required: required,
        id: id,
        ref: mergeRefs([internalRef, ref]),
        value: value,
        onChange: onChange,
        placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
        culture: locale,
        onFocus: function onFocus(event) {
          setFocussed(true);
          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          setFocussed(false);
          if (_onBlur) {
            _onBlur(event);
          }
        },
        disabled: disabled || readOnly,
        "aria-invalid": error != null
      }));
    });
  });
}
var TimeInput$1 = /*#__PURE__*/forwardRef(TimeInput);// Code taken from https://github.com/sindresorhus/array-move
// We cannot use this module directly as it does not offer
// an ES5 bundle for IE11 compatibility.

var arrayMove = function arrayMove(inputArray, from, to) {
  var array = _toConsumableArray(inputArray);
  var startIndex = from < 0 ? array.length + from : from;
  if (startIndex >= 0 && startIndex < array.length) {
    var endIndex = to < 0 ? array.length + to : to;
    var _array$splice = array.splice(from, 1),
      _array$splice2 = _slicedToArray(_array$splice, 1),
      item = _array$splice2[0];
    array.splice(endIndex, 0, item);
  }
  return array;
};
var arrayMove$1 = arrayMove;var _excluded$8 = ["id", "value", "label", "labelPosition", "description", "readOnly", "disabled", "required", "clearable", "sortable", "children", "addLabel", "addAction", "getItemKey", "defaultValue", "validateValue", "placeholder", "readOnlyPlaceholder", "onChange", "addOnEnter", "addOnBlur", "onFocus", "onBlur"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function List(_ref) {
  var id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    _ref$sortable = _ref.sortable,
    sortable = _ref$sortable === void 0 ? true : _ref$sortable,
    children = _ref.children,
    addLabel = _ref.addLabel,
    _ref$addAction = _ref.addAction,
    addAction = _ref$addAction === void 0 ? 'manual' : _ref$addAction,
    _ref$getItemKey = _ref.getItemKey,
    getItemKey = _ref$getItemKey === void 0 ? identity : _ref$getItemKey,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    _ref$validateValue = _ref.validateValue,
    validateValue = _ref$validateValue === void 0 ? isDefined : _ref$validateValue,
    placeholder = _ref.placeholder,
    readOnlyPlaceholder = _ref.readOnlyPlaceholder,
    _onChange = _ref.onChange,
    _ref$addOnEnter = _ref.addOnEnter,
    addOnEnter = _ref$addOnEnter === void 0 ? true : _ref$addOnEnter,
    _ref$addOnBlur = _ref.addOnBlur,
    addOnBlur = _ref$addOnBlur === void 0 ? true : _ref$addOnBlur,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    newItem = _useState2[0],
    setNewItem = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setHasFocus = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    dragIndex = _useState6[0],
    setDragIndex = _useState6[1];
  useEffect(function () {
    setNewItem(defaultValue);
  }, [defaultValue]);
  var portalHost = useContext(PortalContext) || document.body;
  var hideInput = readOnly && value.length > 0;
  function addItemOnBlur(newItem) {
    if (_onChange && validateValue(newItem)) {
      _onChange([].concat(_toConsumableArray(value), [newItem]));
      setNewItem(defaultValue);
    }
  }
  var isItemClearableByProps = !readOnly && !disabled && clearable;
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    required: required,
    label: label,
    labelPosition: labelPosition,
    description: description
  }, function (fieldId) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, sortable ? /*#__PURE__*/React.createElement(SortableItems, _extends({
      useDragHandle: true,
      lockAxis: "y",
      helperContainer: portalHost,
      shouldCancelStart: function shouldCancelStart(event) {
        return _isInsideButton(event.target);
      },
      onSortEnd: function onSortEnd(_ref2) {
        var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;
        if (_onChange) {
          _onChange(arrayMove$1(value, oldIndex, newIndex));
        }
        setDragIndex(null);
      }
      // Try to refactor this if you dare :)
      // The react-sortable-hoc does some weird stuff if this
      // method is implemented which causes the tests to fail
      // even though everything is correct. I've debugged
      // for an hour and tired now. This going to stay :)
    }, process.env.NODE_ENV !== 'test' ? {
      updateBeforeSortStart: function updateBeforeSortStart(_ref3) {
        var index = _ref3.index;
        return setDragIndex(index);
      }
    } : {}), value.map(function (item, index) {
      return /*#__PURE__*/React.createElement(SortableItem, {
        key: getItemKey(item, index),
        index: index,
        disabled: readOnly || disabled,
        dragging: dragIndex === index
      }, children({
        readOnly: !disabled,
        disabled: disabled,
        role: 'listitem',
        value: item,
        icon: readOnly || disabled ? undefined : /*#__PURE__*/React.createElement(DragHandle, null),
        label: null,
        controls: isItemClearableByProps && dragIndex !== index && /*#__PURE__*/React.createElement(IconButton, {
          "data-testid": "reset-button",
          "aria-label": "remove item from list",
          icon: "reset",
          onClick: function onClick() {
            if (_onChange) {
              _onChange(value.filter(function (_, itemIndex) {
                return itemIndex !== index;
              }));
            }
          }
        })
      }));
    })) : /*#__PURE__*/React.createElement(NonSortableItems, null, value.map(function (item, index) {
      return /*#__PURE__*/React.createElement(NonSortableItem, {
        disabled: readOnly || disabled
      }, children({
        readOnly: !disabled,
        disabled: disabled,
        role: 'listitem',
        value: item,
        label: null,
        controls: isItemClearableByProps && /*#__PURE__*/React.createElement(IconButton, {
          "data-testid": "reset-button",
          "aria-label": "remove item from list",
          icon: "reset",
          onClick: function onClick() {
            if (_onChange) {
              _onChange(value.filter(function (_, itemIndex) {
                return itemIndex !== index;
              }));
            }
          }
        })
      }));
    })), !hideInput && children(_objectSpread$5(_objectSpread$5({}, rest), {}, {
      readOnly: readOnly,
      disabled: disabled,
      id: fieldId,
      label: null,
      addItemOnBlur: addItemOnBlur,
      clearable: false,
      placeholder: readOnly ? readOnlyPlaceholder || placeholder : placeholder,
      onChange: function onChange(newValue) {
        if (!_onChange) {
          return;
        }
        if (addAction === 'change') {
          invariant(newValue != null, 'Cannot add undefined item.');
          _onChange([].concat(_toConsumableArray(value), [newValue]));
        } else {
          setNewItem(newValue);
        }
      },
      onFocus: function onFocus(event) {
        if (_onFocus) {
          _onFocus(event);
        }
        setHasFocus(true);
      },
      onBlur: function onBlur(event) {
        if (_onBlur) {
          _onBlur(event);
        }
        if (!validateValue(newItem)) {
          setHasFocus(false);
        }
        if (addOnBlur) {
          addItemOnBlur(newItem);
        }
      },
      onKeyDown: function onKeyDown(event) {
        if (!_onChange) {
          return;
        }
        if (event.key === 'Enter' && validateValue(newItem) && addOnEnter) {
          _onChange([].concat(_toConsumableArray(value), [newItem]));
          setNewItem(defaultValue);
        }
      },
      required: required,
      value: newItem,
      controls: addAction === 'manual' && !readOnly && /*#__PURE__*/React.createElement(AddAction, {
        hasFocus: hasFocus,
        disabled: disabled || !validateValue(newItem),
        addLabel: addLabel,
        onAdd: function onAdd() {
          if (!_onChange) {
            return;
          }
          invariant(validateValue(newItem), 'Cannot add an undefined item to the list.');
          _onChange([].concat(_toConsumableArray(value), [newItem]));
          setNewItem(defaultValue);
          setHasFocus(false);
        }
      })
    })));
  });
}
var _isInsideButton = function isInsideButton(node) {
  if (!node) {
    return false;
  }
  if (node instanceof HTMLButtonElement) {
    return true;
  }
  return _isInsideButton(node.parentNode);
};
var identity = function identity(item, index) {
  return "".concat(item, "-").concat(index);
};
var isDefined = function isDefined(value) {
  return value != null;
};
var AddAction = function AddAction(_ref4) {
  var hasFocus = _ref4.hasFocus,
    disabled = _ref4.disabled,
    addLabel = _ref4.addLabel,
    onAdd = _ref4.onAdd;
  if (disabled && !hasFocus) {
    return /*#__PURE__*/React.createElement(IconButton, {
      disabled: true,
      "aria-hidden": true,
      tabIndex: -1,
      icon: "add"
    });
  }
  invariant(addLabel, 'You need to specify the "addLabel" prop.');
  return /*#__PURE__*/React.createElement(FlatButton, {
    icon: "add",
    disabled: disabled,
    onClick: onAdd,
    type: "button"
  }, addLabel);
};
var DragHandle = sortableHandle(function () {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "sortable-element"
  }, /*#__PURE__*/React.createElement(Glyph, null, "drag-sort"));
});
var SortableItems = SortableContainer(function (_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "list"
  }, children);
});
var NonSortableItem = function NonSortableItem(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "list"
  }, children);
};
var SortableItem = SortableElement(function (_ref7) {
  var children = _ref7.children,
    dragging = _ref7.dragging;
  var styles = useStyles$2(itemStyles, {}, {
    '&dragging': dragging
  });
  return /*#__PURE__*/React.createElement("div", styles, children);
});
var NonSortableItems = function NonSortableItems(_ref8) {
  var children = _ref8.children;
  var styles = useStyles$2(itemStyles, {}, {});
  return /*#__PURE__*/React.createElement("div", styles, children);
};
var itemStyles = function itemStyles(_ref9) {
  var color = _ref9.color,
    shadow = _ref9.shadow,
    zIndex = _ref9.zIndex;
  return {
    cursor: 'grab',
    '&dragging': _objectSpread$5({
      backgroundColor: color.surface,
      cursor: 'grabbing',
      border: 2,
      overflow: 'hidden',
      zIndex: zIndex.draggable
    }, shadow.menu)
  };
};var _excluded$7 = ["disabled", "toggled", "title", "onChange"];
function ToggleSwitch(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$toggled = _ref.toggled,
    toggled = _ref$toggled === void 0 ? false : _ref$toggled,
    title = _ref.title,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  var styles = useStyles$2(defaultStyles$d, {}, {
    '&disabled': disabled,
    '&toggled': toggled
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, styles, {
    title: title || undefined,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (!disabled) {
        onChange(!toggled, e);
      }
    },
    role: "button",
    tabIndex: 0,
    "aria-hidden": "true"
  }));
}
var TOGGLE_SWITCHER_DIAMETER = 26;
var TOGGLE_HEIGHT = TOGGLE_SWITCHER_DIAMETER;
var TOGGLE_WIDTH = 40;
var TOGGLE_BACK_LAYER_HEIGHT = 16;
var defaultStyles$d = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    position: 'relative',
    width: TOGGLE_WIDTH,
    height: TOGGLE_HEIGHT,
    outline: 'none',
    cursor: 'pointer',
    ':after': {
      content: '""',
      display: 'block',
      height: TOGGLE_SWITCHER_DIAMETER,
      width: TOGGLE_SWITCHER_DIAMETER,
      border: [1, 'solid', color.text.disabled],
      position: 'absolute',
      borderRadius: '50%',
      overflow: 'hidden',
      left: 0,
      backgroundColor: color.background,
      transition: 'all 0.3s ease-in-out'
    },
    ':before': {
      content: '""',
      display: 'block',
      height: TOGGLE_BACK_LAYER_HEIGHT,
      width: TOGGLE_WIDTH,
      borderRadius: TOGGLE_BACK_LAYER_HEIGHT / 2,
      overflow: 'hidden',
      backgroundColor: color.divider.base,
      top: '50%',
      position: 'absolute',
      transform: 'translateY(-50%)',
      border: [1, 'solid', color.text.disabled],
      transition: 'all 0.3s ease-in-out'
    },
    '&disabled': {
      cursor: 'not-allowed',
      opacity: 0.42
    },
    '&toggled': {
      ':after': {
        left: TOGGLE_WIDTH - TOGGLE_SWITCHER_DIAMETER,
        borderColor: color.primary.base,
        backgroundColor: color.primary.base
      },
      ':before': {
        borderColor: color.shading.onLight
      }
    }
  };
};var _excluded$6 = ["id", "label", "min", "max", "value", "defaultValue", "step", "orient", "size", "disabled", "onChange", "ariaLabelledby", "ariaControls"];
var SLIDER_ADJACENT_SIZE = 20;
var THUMB_SIZE = 12;
var BAR_SIZE = 2;
var round$1 = function round(number) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  return Math.round(number * units) / units;
};
var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
};
var getPercentageFromValue = function getPercentageFromValue(value, minValue, maxValue) {
  var validValue = clamp(value, minValue, maxValue);
  var valueDiff = maxValue - minValue;
  var valuePerc = (validValue - minValue) / valueDiff;
  return valuePerc || 0;
};
var Slider = function Slider(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'slider' : _ref$id,
    label = _ref.label,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 'any' : _ref$step,
    _ref$orient = _ref.orient,
    orient = _ref$orient === void 0 ? 'horizontal' : _ref$orient,
    size = _ref.size,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    ariaLabelledby = _ref.ariaLabelledby,
    ariaControls = _ref.ariaControls,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  var _useState = useState(value || defaultValue || 0),
    _useState2 = _slicedToArray(_useState, 2),
    sliderValue = _useState2[0],
    setSliderValue = _useState2[1];
  var isVertical = orient === 'vertical';
  var sliderSize = size || 100;
  var styles = useStyles$2(defaultStyles$c, {}, {
    '&vertical': isVertical,
    '&horizontal': !isVertical,
    '&disabled': !!disabled
  });
  var onChangeCallback = useCallback(function (scale) {
    return onChange === null || onChange === void 0 ? void 0 : onChange(scale);
  }, [onChange]);
  var handleChange = function handleChange(event) {
    if (event.target.value > max || event.target.value < min) return;
    setSliderValue(event.target.value);
    onChangeCallback({
      percentage: getPercentageFromValue(event.target.value, min, max),
      scale: event.target.value
    });
  };
  useEffect(function () {
    setSliderValue(value || 0);
  }, [value]);
  var thumbScaler = round$1(THUMB_SIZE * getPercentageFromValue(sliderValue, min, max));
  var thumbPercentage = round$1(getPercentageFromValue(sliderValue, min, max) * 100);
  var thumbPosition = "calc(".concat(thumbPercentage, "% - ").concat(thumbScaler, "px)");
  var sliderInlineStyles = {
    width: isVertical ? SLIDER_ADJACENT_SIZE : size ? sliderSize : '100%',
    height: isVertical ? sliderSize : SLIDER_ADJACENT_SIZE
  };
  return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement("div", _extends({}, inline(styles('slider'), sliderInlineStyles), rest, {
    role: "presentation",
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    }
  }), /*#__PURE__*/React.createElement("input", _extends({}, inline(styles('sliderInput'), sliderInlineStyles), {
    id: id,
    type: "range",
    orient: orient,
    step: step,
    min: min,
    max: max,
    value: sliderValue,
    defaultValue: defaultValue,
    disabled: disabled,
    onChange: handleChange,
    "aria-orientation": orient,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    "aria-valuetext": value ? "".concat(value, "%") : '',
    "aria-label": ariaLabelledby || id || 'slider',
    "aria-labelledby": ariaLabelledby || id || 'slider',
    "aria-controls": ariaControls
  })), /*#__PURE__*/React.createElement("label", _extends({}, styles('visuallyHidden'), {
    htmlFor: id || 'slider'
  }), label), /*#__PURE__*/React.createElement("div", inline(styles('sliderTrack'), {
    height: isVertical ? sliderSize : BAR_SIZE
  })), /*#__PURE__*/React.createElement("div", inline(styles('sliderThumb'), {
    left: isVertical ? '50%' : "".concat(thumbPosition),
    bottom: isVertical && "".concat(thumbPosition)
  }))));
};
var defaultStyles$c = function defaultStyles(_ref2) {
  var color = _ref2.color;
    _ref2.zIndex;
    var spacing = _ref2.spacing;
  return {
    backgroundColor: color.surface,
    padding: "".concat(spacing.xsmall, "px ").concat(spacing.xxxsmall, "px"),
    overflow: 'visible',
    slider: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'visible',
      margin: '6px 0'
    },
    visuallyHidden: {
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(50%)',
      height: '1px',
      overflow: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px'
    },
    sliderInput: {
      opacity: 0,
      position: 'relative',
      width: '100%',
      margin: 0,
      padding: 0,
      display: 'block',
      backgroundColor: 'transparent',
      appearance: 'none',
      cursor: 'pointer',
      ':focus': {
        outline: 'none'
      },
      ':hover': {
        color: 'azure',
        sliderThumb: {
          boxShadow: "0px 0px 2px 4px ".concat(color.activeHover.primary)
        }
      },
      ':active': {
        sliderThumb: {
          boxShadow: "0px 0px 2px 6px ".concat(color.activeHover.primary)
        }
      },
      '::-webkit-slider-runnable-track': {
        background: color.mono.lighter,
        border: "1px solid ".concat(color.mono.lighter),
        borderRadius: '25px',
        width: '100%',
        height: '2px',
        cursor: 'pointer'
      },
      '::-moz-range-track': {
        background: color.mono.lighter,
        border: "1px solid ".concat(color.mono.lighter),
        borderRadius: '25px',
        width: '100%',
        height: '2px',
        cursor: 'pointer'
      },
      '::-ms-track': {
        background: 'transparent',
        borderColor: 'transparent',
        borderWidth: '7px 0',
        color: 'transparent',
        width: '100%',
        height: '2px',
        cursor: 'pointer'
      },
      '::-ms-fill-lower': {
        background: '#b7b7b7',
        border: "1px solid ".concat(color.mono.lighter),
        borderRadius: '50px'
      },
      '::-ms-fill-upper': {
        background: color.mono.lighter,
        border: "1px solid ".concat(color.mono.lighter),
        borderRadius: '50px'
      },
      '::-webkit-slider-thumb': {
        marginTop: '-7px',
        width: '12px',
        height: '12px',
        background: color.primary.base,
        border: "1px solid ".concat(color.primary.base),
        borderRadius: '50px',
        cursor: 'pointer',
        appearance: 'none'
      },
      '::-moz-range-thumb': {
        width: '12px',
        height: '12px',
        background: color.primary.base,
        border: "1px solid ".concat(color.primary.base),
        borderRadius: '50px',
        cursor: 'pointer'
      },
      '::-ms-thumb': {
        width: '12px',
        height: '12px',
        background: color.primary.base,
        border: "1px solid ".concat(color.primary.base),
        borderRadius: '50px',
        cursor: 'pointer',
        marginTop: '0px'
      }
    },
    sliderTrack: {
      position: 'absolute',
      pointerEvents: 'none',
      backgroundColor: color.mono.lighter,
      borderRadius: '10px',
      zIndex: 1,
      cursor: 'pointer',
      top: '50%'
    },
    sliderThumb: {
      width: THUMB_SIZE,
      height: THUMB_SIZE,
      position: 'absolute',
      background: color.primary.base,
      borderRadius: '50%',
      pointerEvents: 'none',
      zIndex: 2,
      cursor: 'pointer'
    },
    '&vertical': {
      sliderInput: {
        writingMode: 'bt-lr',
        appearance: 'slider-vertical'
      },
      sliderThumb: {
        transform: 'translateX(-50%)'
      },
      sliderTrack: {
        left: '50%',
        width: BAR_SIZE,
        transform: 'translate(-50%, -50%)'
      }
    },
    '&horizontal': {
      sliderThumb: {
        top: '50%',
        transform: 'translateY(-50%)'
      },
      sliderTrack: {
        left: 0,
        right: 0,
        transform: 'translateY(-50%)'
      }
    },
    '&disabled': {
      sliderInput: {
        cursor: 'default',
        '::-webkit-slider-runnable-track': {
          cursor: 'default'
        },
        '::-moz-range-track': {
          cursor: 'default'
        },
        '::-ms-track': {
          cursor: 'default'
        },
        '::-webkit-slider-thumb': {
          cursor: 'default'
        },
        '::-moz-range-thumb': {
          cursor: 'default'
        },
        '::-ms-thumb': {
          cursor: 'default'
        }
      },
      sliderThumb: {
        background: color.mono.middle,
        boxShadow: 'none',
        cursor: 'default'
      }
    }
  };
};
var Slider$1 = Slider;function FileValue(_ref) {
  var clearable = _ref.clearable,
    disabled = _ref.disabled;
    _ref.required;
    var value = _ref.value,
    icon = _ref.icon,
    onClear = _ref.onClear,
    src = _ref.src,
    rel = _ref.rel,
    controls = _ref.controls;
  var link = useRef();
  var styles = useStyles$2(defaultStyles$b, {}, {
    '&disabled': disabled,
    '&interactive': !disabled
  });
  var showClearable = clearable && !disabled;
  return (
    /*#__PURE__*/
    // Please fix me
    // jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions
    // eslint-disable-next-line
    React.createElement("div", _extends({}, styles, {
      onClick: function onClick(event) {
        if (link.current && link.current !== event.target) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      value: value,
      styles: styles
    }), src ? /*#__PURE__*/React.createElement("a", _extends({}, styles('fileName'), {
      rel: rel,
      ref: link,
      href: src,
      download: true
    }), value.name) : /*#__PURE__*/React.createElement("div", styles('fileName'), value.name), /*#__PURE__*/React.createElement(Box$1, {
      marginLeft: "xsmall",
      marginRight: "xxsmall"
    }, /*#__PURE__*/React.createElement(Tag, {
      small: true
    }, fileUtils.getReadableSize(value.size))), showClearable && /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Clear input",
      icon: "reset",
      onClick: function onClick(event) {
        event.stopPropagation();
        onClear();
      }
    }), controls)
  );
}
var defaultStyles$b = function defaultStyles(_ref2) {
  var font = _ref2.font,
    color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    fontSize: font.body.fontSize,
    display: 'flex',
    alignItems: 'center',
    height: 40,
    borderBottom: "1px solid ".concat(color.text.inactive),
    icon: {
      marginLeft: spacing.xsmall,
      color: color.text.disabled
    },
    dragIcon: {
      marginLeft: spacing.xsmall,
      color: color.text.disabled,
      cursor: 'grab'
    },
    fileName: {
      marginLeft: spacing.xsmall,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      flex: 1
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      }
    },
    '&disabled': {
      backgroundColor: 'transparent',
      borderBottom: "1px solid ".concat(color.divider.base)
    }
  };
};
function Icon(_ref3) {
  var icon = _ref3.icon,
    value = _ref3.value,
    styles = _ref3.styles;
  if (!icon) {
    return /*#__PURE__*/React.createElement(Glyph, {
      "data-testid": "file-icon",
      style: styles('icon')
    }, getIconName(value));
  }
  return typeof icon === 'string' ? /*#__PURE__*/React.createElement(Glyph, {
    "data-testid": "file-icon",
    style: styles('icon')
  }, icon) : /*#__PURE__*/React.createElement("div", _extends({}, styles('dragIcon'), {
    "data-testid": "file-icon"
  }), icon);
}
function getIconName(_ref4) {
  var type = _ref4.type,
    name = _ref4.name;
  if (fileUtils.isImage(type, name)) {
    return 'picture';
  }
  if (fileUtils.isPdf(type, name)) {
    return 'adobe-pdf';
  }
  if (fileUtils.isWord(type, name)) {
    return 'microsoft-word';
  }
  if (fileUtils.isSpreadsheet(type, name)) {
    return 'microsoft-excel';
  }
  if (fileUtils.isPowerPoint(type, name)) {
    return 'microsoft-powerpoint';
  }
  if (fileUtils.isArchive(type, name)) {
    return 'file-archive';
  }
  if (fileUtils.isFolder(type, name)) {
    return 'folder';
  }
  return 'file';
}var _excluded$5 = ["id", "draggingLabel", "label", "accept", "error", "disabled", "required", "value", "clearable", "readOnly", "src", "icon", "onChange", "rel", "controls"];
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function DropZone(_ref) {
  var id = _ref.id,
    draggingLabel = _ref.draggingLabel,
    label = _ref.label,
    accept = _ref.accept,
    error = _ref.error,
    disabled = _ref.disabled,
    required = _ref.required,
    value = _ref.value,
    clearable = _ref.clearable,
    readOnly = _ref.readOnly,
    src = _ref.src,
    icon = _ref.icon,
    _onChange = _ref.onChange,
    rel = _ref.rel,
    controls = _ref.controls,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  var dragging = useDragging();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    draggingOver = _useState2[0],
    setDraggingOver = _useState2[1];
  var _useTheme = useTheme$1(),
    border = _useTheme.border;
  var borderRadius = border.tab.borderRadius;
  var defaultStyles = function defaultStyles(_ref2) {
    var color = _ref2.color,
      spacing = _ref2.spacing,
      font = _ref2.font;
    return _objectSpread$4(_objectSpread$4({
      cursor: 'default',
      color: color.text.base,
      fontSize: font.size.small,
      boxShadow: "0px -1px ".concat(color.text.inactive, " inset"),
      backgroundColor: color.shading.onLight
    }, transition(['padding-bottom', 'padding-top'])), {}, {
      label: {
        cursor: 'default'
      },
      '&empty': {
        label: {
          borderRadius: borderRadius.regular,
          fontSize: font.size.normal,
          textAlign: 'center',
          paddingTop: spacing.xsmall,
          paddingRight: spacing.xsmall,
          paddingBottom: spacing.xsmall,
          paddingLeft: spacing.xsmall,
          borderLeft: "dashed 1px ".concat(color.divider.base),
          borderTop: "dashed 1px ".concat(color.divider.base),
          borderRight: "dashed 1px ".concat(color.divider.base)
        }
      },
      '&interactive': {
        '&empty': {
          label: {
            cursor: 'pointer',
            ':hover': {
              backgroundColor: color.hover.base
            },
            ':focus-within': {
              backgroundColor: color.active.secondary,
              boxShadow: "0px -2px ".concat(color.secondary.base, " inset")
            }
          }
        }
      },
      '&disabled': {
        backgroundColor: 'transparent',
        boxShadow: "0px -1px ".concat(color.divider.base, " inset"),
        color: color.text.disabled,
        cursor: 'default',
        label: {
          color: color.text.disabled
        },
        ':hover': {
          backgroundColor: 'transparent'
        }
      },
      '&readOnly': {
        backgroundColor: 'transparent',
        boxShadow: "0px -1px ".concat(color.divider.base, " inset")
      },
      '&dragging': {
        backgroundColor: color.active.secondary,
        boxShadow: "0px -2px ".concat(color.coloredText.secondary, " inset"),
        '&empty': {
          label: {
            paddingTop: spacing.medium,
            paddingBottom: spacing.medium
          }
        },
        label: {
          borderLeft: "dashed 1px ".concat(color.coloredText.secondary),
          borderTop: "dashed 1px ".concat(color.coloredText.secondary),
          borderRight: "dashed 1px ".concat(color.coloredText.secondary)
        }
      },
      '&draggingOver': {
        backgroundColor: color.activeHover.secondary
      },
      '&error': {
        boxShadow: "0px -1px ".concat(color.danger.base, " inset")
      }
    });
  };
  var styles = useStyles$2(defaultStyles, {}, {
    '&error': error,
    '&dragging': dragging && !disabled && !readOnly,
    '&draggingOver': draggingOver && !disabled && !readOnly,
    '&disabled': disabled,
    '&readOnly': readOnly,
    '&interactive': !readOnly && !disabled,
    '&empty': !value
  });
  return /*#__PURE__*/React.createElement("div", {
    onDragOver: function onDragOver() {
      return setDraggingOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setDraggingOver(false);
    },
    onDrop: function onDrop() {
      return setDraggingOver(false);
    }
  }, /*#__PURE__*/React.createElement(File, _extends({}, rest, {
    "aria-describedby": descriptionId(id),
    "aria-invalid": error ? 'true' : 'false',
    id: id,
    readOnly: readOnly,
    disabled: disabled,
    required: required,
    onChange: function onChange(file) {
      if (disabled || readOnly) {
        return;
      }
      _onChange(file);
    },
    style: styles,
    accept: accept,
    value: value
  }), value ? /*#__PURE__*/React.createElement(FileValue, {
    clearable: clearable,
    disabled: disabled || readOnly,
    required: required,
    value: value,
    controls: controls,
    icon: icon,
    onClear: function onClear() {
      if (_onChange) {
        _onChange(null);
      }
    },
    src: src,
    rel: rel
  }) : dragging && !disabled && !readOnly ? draggingLabel : label));
}
function useDragging() {
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragging = _useState4[0],
    setDragging = _useState4[1];
  useEffect(function () {
    var handleDragEnter = function handleDragEnter(event) {
      var _event$dataTransfer;
      if (((_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer.items.length) !== 1) {
        return;
      }
      var draggedItem = event.dataTransfer.items[0];
      if (draggedItem.kind === 'file') {
        setDragging(true);
      }
    };
    var handleMouseLeave = function handleMouseLeave() {
      if (dragging) {
        setDragging(false);
      }
    };
    document.addEventListener('dragenter', handleDragEnter);
    document.addEventListener('drop', handleMouseLeave);
    document.addEventListener('mouseleave', handleMouseLeave);
    return function () {
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('drop', handleMouseLeave);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [dragging]);
  return dragging;
}var _excluded$4 = ["id", "onChange", "labelPosition", "description", "label", "required", "value", "accept", "hint", "clearable", "icon", "dropZoneLabel", "dropZoneDraggingLabel", "disabled", "error", "readOnly", "src", "controls"];
function FileInput(_ref) {
  var id = _ref.id,
    _onChange = _ref.onChange,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    description = _ref.description,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    accept = _ref.accept,
    hint = _ref.hint,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    icon = _ref.icon,
    dropZoneLabel = _ref.dropZoneLabel,
    _ref$dropZoneDragging = _ref.dropZoneDraggingLabel,
    dropZoneDraggingLabel = _ref$dropZoneDragging === void 0 ? dropZoneLabel : _ref$dropZoneDragging,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    src = _ref.src,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? null : _ref$controls,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement(Label, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    description: description,
    required: required
  }, function (id) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropZone, _extends({}, rest, {
      controls: controls,
      disabled: disabled,
      required: required,
      clearable: clearable,
      readOnly: readOnly,
      error: error != null,
      id: id,
      value: value,
      icon: icon,
      label: dropZoneLabel,
      draggingLabel: dropZoneDraggingLabel,
      accept: accept,
      src: src,
      onChange: function onChange(file) {
        if (_onChange) {
          _onChange(file);
        }
      }
    })), (error || hint) && /*#__PURE__*/React.createElement(Box$1, {
      marginTop: "xxxsmall",
      marginBottom: "xxxsmall",
      marginLeft: "xsmall",
      marginRight: "xsmall"
    }, /*#__PURE__*/React.createElement(InputFooter, {
      htmlFor: id,
      error: error,
      hint: hint
    })));
  });
}function sanitizeMatch(match) {
  return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function sanitizeSvgString() {
  var svg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var encodedSvg = encodeURIComponent(svg);
  var unescapedSvg = unescape(encodedSvg);
  return unescapedSvg.replace(/&nbsp;/g, ' ').replace(/="([^"]*(<|>)[^"]*)"/g, sanitizeMatch);
}
var SvgImg = function SvgImg(_ref) {
  var svg = _ref.svg,
    alt = _ref.alt,
    _ref$frame = _ref.frame,
    frame = _ref$frame === void 0 ? 'flex' : _ref$frame,
    withoutBorder = _ref.withoutBorder,
    imgStyle = _ref.imgStyle;
  var styles = useStyles$2(defaultStyles$a, {}, {
    '&withoutBorder': !!withoutBorder,
    '&flex': frame === 'flex',
    '&fixed': frame === 'fixed'
  });
  var memoizedSVG = useMemo(function () {
    return btoa(sanitizeSvgString(svg));
  }, [svg]);
  return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement("span", styles('aligner')), svg ? /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/svg+xml;base64,".concat(memoizedSVG),
    alt: alt
  }, inline(styles('image'), imgStyle))) : null);
};
var defaultStyles$a = function defaultStyles(_ref2) {
  var color = _ref2.color;
    _ref2.zIndex;
  return {
    /*    
    the image doesn't scale properly on IE 11
     that's why we replaced the display:flex with the aligner
    */
    aligner: {
      height: '100%',
      verticalAlign: 'middle',
      width: '1px'
    },
    '&flex': {
      border: "1px solid ".concat(color.divider.base),
      height: '100%',
      width: '100%',
      image: {
        maxWidth: '100%',
        maxHeight: '100%',
        verticalAlign: 'middle',
        overflow: 'hidden'
      }
    },
    '&fixed': {
      display: 'flex',
      justifyContent: 'center',
      border: "1px solid ".concat(color.divider.base),
      borderRadius: '2px',
      height: '96px',
      width: '160px',
      image: {
        maxHeight: '96px',
        maxWidth: '160px',
        verticalAlign: 'middle',
        alignSelf: 'center',
        overflow: 'hidden'
      }
    },
    '&withoutBorder': {
      border: 'none'
    }
  };
};
var SvgImg$1 = SvgImg;function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useMiniMapIndicator = function useMiniMapIndicator(_ref) {
  var ratio = _ref.ratio,
    viewSize = _ref.viewSize,
    translate = _ref.translate,
    adjusting = _ref.adjusting,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 0 : _ref$padding;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    indicatorRect = _useState2[0],
    setIndicatorRect = _useState2[1];
  var setIndicatorPosition = function setIndicatorPosition() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      x: 0,
      y: 0
    };
    setIndicatorRect(function (rect) {
      if (!rect) return null;
      return _objectSpread$3(_objectSpread$3({}, rect), {}, {
        left: position.x - rect.width / 2,
        top: position.y - rect.height / 2
      });
    });
  };
  useEffect(function () {
    if (!adjusting && viewSize !== null && viewSize !== void 0 && viewSize.height && viewSize !== null && viewSize !== void 0 && viewSize.width && !!ratio && translate) {
      setIndicatorRect({
        left: translate.x * -ratio - padding,
        top: translate.y * -ratio - padding,
        height: viewSize.height * ratio + padding * 2,
        width: viewSize.width * ratio + padding * 2
      });
    }
  }, [adjusting, padding, ratio, translate, viewSize === null || viewSize === void 0 ? void 0 : viewSize.height, viewSize === null || viewSize === void 0 ? void 0 : viewSize.width]);
  return {
    indicatorRect: indicatorRect,
    setIndicatorPosition: setIndicatorPosition
  };
};
var useMiniMapIndicator$1 = useMiniMapIndicator;var _excluded$3 = ["svg", "diagramSize", "viewSize", "translate", "setTranslate", "adjusting", "width", "height", "isIdle", "className"];
function MiniMap(_ref, ref) {
  var svg = _ref.svg,
    diagramSize = _ref.diagramSize,
    viewSize = _ref.viewSize,
    translate = _ref.translate,
    setTranslate = _ref.setTranslate,
    adjusting = _ref.adjusting,
    _ref$width = _ref.width,
    miniMapWidth = _ref$width === void 0 ? 200 : _ref$width,
    _ref$height = _ref.height,
    miniMapHeight = _ref$height === void 0 ? 200 : _ref$height,
    isIdle = _ref.isIdle,
    className = _ref.className;
    _objectWithoutProperties(_ref, _excluded$3);
  var fioriStyles = useFioriStyles$1();
  var containerRef = useRef(null);
  var contentRef = useRef();
  var indicatorRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMoving = _useState2[0],
    setIsMoving = _useState2[1];
  var ratio = useMemo(function () {
    var _contentRef$current;
    var miniMapContentRect = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getBoundingClientRect();
    if (miniMapContentRect && diagramSize) {
      return Math.min(miniMapContentRect.width / diagramSize.width, miniMapContentRect.height / diagramSize.height);
    }
    return 0;
  }, [diagramSize]);
  var styles = useStyles$2(defaultStyles$9, {
    className: className
  }, {
    '&idleState': !!isIdle,
    '&fioriStyles': fioriStyles
  });
  var _useMiniMapIndicator = useMiniMapIndicator$1({
      ratio: ratio,
      viewSize: viewSize,
      translate: translate,
      adjusting: adjusting || isMoving,
      padding: 2
    }),
    indicatorRect = _useMiniMapIndicator.indicatorRect,
    setIndicatorPosition = _useMiniMapIndicator.setIndicatorPosition;
  var calcIndicatorPosition = function calcIndicatorPosition(_ref2) {
    var _contentRef$current2;
    var clientX = _ref2.clientX,
      clientY = _ref2.clientY;
    var _ref3 = ((_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 ? void 0 : _contentRef$current2.getBoundingClientRect()) || {},
      _ref3$left = _ref3.left,
      left = _ref3$left === void 0 ? 0 : _ref3$left,
      _ref3$top = _ref3.top,
      top = _ref3$top === void 0 ? 0 : _ref3$top;
    return {
      x: clientX - left,
      y: clientY - top
    };
  };
  var handleClick = function handleClick(ev) {
    var _indicatorRef$current;
    ev.preventDefault();
    ev.stopPropagation();
    if (adjusting) return;
    setIsMoving(true);
    if (!((_indicatorRef$current = indicatorRef.current) !== null && _indicatorRef$current !== void 0 && _indicatorRef$current.contains(ev.target))) {
      setIndicatorPosition(calcIndicatorPosition(ev));
    }
  };
  var handleMove = function handleMove(ev) {
    if (isMoving) {
      setIndicatorPosition(calcIndicatorPosition(ev));
    }
  };
  var handleRelease = function handleRelease(ev) {
    ev.stopPropagation();
    setIsMoving(false);
  };
  useEffect(function () {
    if (isMoving && !!indicatorRect && setTranslate) {
      setTranslate(function (translate) {
        return {
          x: indicatorRect.left / -ratio || translate.x,
          y: indicatorRect.top / -ratio || translate.y
        };
      });
    }
  }, [isMoving, setTranslate, indicatorRect, ratio]);
  useEffect(function () {
    window.addEventListener('mouseup', handleRelease);
    return function () {
      window.removeEventListener('mouseup', handleRelease);
    };
  }, []);
  var containerInlineStyle = {
    cursor: isMoving ? 'move' : 'inherit',
    width: miniMapWidth,
    height: miniMapHeight
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "presentation",
    ref: containerRef,
    "data-testid": "mini-map-container",
    onMouseDown: handleClick,
    onMouseMove: handleMove
  }, inline(styles, containerInlineStyle)), /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "aria-label": isIdle ? 'idle minimap' : 'non idle minimap'
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: contentRef
  }, inline(styles('content'))), /*#__PURE__*/React.createElement(SvgImg$1, {
    svg: svg,
    alt: "Diagram navigation image",
    withoutBorder: true,
    imgStyle: {
      maxHeight: miniMapHeight,
      maxWidth: miniMapWidth
    }
  }), indicatorRect && /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "mini-map-indicator",
    ref: indicatorRef
  }, styles('indicator'), {
    style: indicatorRect
  })))));
}
var defaultStyles$9 = function defaultStyles(_ref4) {
  var color = _ref4.color;
    _ref4.zIndex;
  return {
    background: color.surface,
    marginTop: 'auto',
    border: "1px solid ".concat(color.divider.base),
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 1px 2px 1px rgb(0 0 0 / 16%), 0 0 1px 0 rgb(0 0 0 / 10%)',
    '&idleState': {
      opacity: '40%',
      transition: 'all 0.3s'
    },
    '&fioriStyles': {
      borderRadius: '12px'
    },
    content: {
      position: 'relative',
      height: '100%'
    },
    indicator: {
      transition: 'all 0.2s',
      position: 'absolute',
      border: "2px solid ".concat(color.contrast)
    }
  };
};
var MiniMap$1 = /*#__PURE__*/forwardRef(MiniMap);var card = {
  boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.16), 0 0 1px 0 rgba(0, 0, 0, 0.10)'
};
var menu = {
  boxShadow: '0 4px 8px 1px rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.10)'
};
var modal = {
  boxShadow: '0 7px 14px 1px rgba(0, 0, 0, 0.16), 0 0 7px 0 rgba(0, 0, 0, 0.10)'
};
var header = {
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)'
};var shadow=/*#__PURE__*/Object.freeze({__proto__:null,card:card,menu:menu,modal:modal,header:header});function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Box(_ref) {
  var children = _ref.children,
    component = _ref.component,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? 'none' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 'none' : _ref$paddingTop,
    _ref$paddingRight = _ref.paddingRight,
    paddingRight = _ref$paddingRight === void 0 ? 'none' : _ref$paddingRight,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 'none' : _ref$paddingBottom,
    _ref$paddingLeft = _ref.paddingLeft,
    paddingLeft = _ref$paddingLeft === void 0 ? 'none' : _ref$paddingLeft,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? 'none' : _ref$shadow;
  var styles = useStyles$3(defaultStyles$8, {
    style: style,
    className: className,
    classNames: classNames
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&margin-top-".concat(marginTop), true), "&margin-right-".concat(marginRight), true), "&margin-bottom-".concat(marginBottom), true), "&margin-left-".concat(marginLeft), true), "&padding-top-".concat(paddingTop), true), "&padding-right-".concat(paddingRight), true), "&padding-bottom-".concat(paddingBottom), true), "&padding-left-".concat(paddingLeft), true), '&shadow', shadow !== 'none'), "&shadow-".concat(shadow), true));
  var Component = component || 'div';
  return /*#__PURE__*/React.createElement(Component, styles, children);
}
var defaultStyles$8 = _objectSpread$2(_objectSpread$2({
  minWidth: 0
}, Object.entries(spacing).reduce(function (result, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
    variant = _ref3[0],
    value = _ref3[1];
  return _objectSpread$2(_objectSpread$2({}, result), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&margin-top-".concat(variant), {
    marginTop: value
  }), "&margin-right-".concat(variant), {
    marginRight: value
  }), "&margin-bottom-".concat(variant), {
    marginBottom: value
  }), "&margin-left-".concat(variant), {
    marginLeft: value
  }), "&padding-top-".concat(variant), {
    paddingTop: value
  }), "&padding-right-".concat(variant), {
    paddingRight: value
  }), "&padding-bottom-".concat(variant), {
    paddingBottom: value
  }), "&padding-left-".concat(variant), {
    paddingLeft: value
  }));
}, Object.freeze({}))), {}, {
  '&shadow': {
    overflow: 'hidden',
    borderRadius: 2
  }
}, Object.entries(shadow).reduce(function (result, _ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
    variant = _ref5[0],
    value = _ref5[1];
  return _objectSpread$2(_objectSpread$2({}, result), {}, _defineProperty({}, "&shadow-".concat(variant), value));
}, Object.freeze({})));var _excluded$2 = ["children", "spacing", "direction", "style", "className", "classNames"];
function Stack(_ref) {
  var children = _ref.children,
    spacing = _ref.spacing,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var styles = useStyles$3(defaultStyles$7, {
    style: style,
    className: className,
    classNames: classNames
  }, _defineProperty({}, "&".concat(direction), true));
  var correctedIndex = 0;
  return /*#__PURE__*/React.createElement("div", _extends({}, styles, rest), Children.map(children, function (child) {
    if (! /*#__PURE__*/isValidElement(child) && typeof child !== 'string') {
      return null;
    }
    var index = correctedIndex;
    correctedIndex++;
    if (direction === 'vertical') {
      return /*#__PURE__*/React.createElement(Box, {
        marginTop: index === 0 ? 'none' : spacing
      }, child);
    }
    return /*#__PURE__*/React.createElement(Box, {
      marginLeft: index === 0 ? 'none' : spacing
    }, child);
  }));
}
var defaultStyles$7 = {
  '&horizontal': {
    display: 'flex'
  }
};var _excluded$1 = ["icon", "tooltipLabel", "tooltipKeyLabel", "children", "active", "popoverPosition", "fullscreen", "small", "onClick", "disabled"];
var PanAndZoomToolbarButton = function PanAndZoomToolbarButton(_ref) {
  var icon = _ref.icon,
    tooltipLabel = _ref.tooltipLabel,
    tooltipKeyLabel = _ref.tooltipKeyLabel,
    children = _ref.children,
    active = _ref.active,
    popoverPosition = _ref.popoverPosition,
    fullscreen = _ref.fullscreen,
    small = _ref.small,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var fioriStyles = useFioriStyles$1();
  var styles = useStyles$2(defaultStyles$6, {}, {
    '&active': !!active,
    '&fioriStyles': fioriStyles
  });
  return /*#__PURE__*/React.createElement(Popover, {
    popover: /*#__PURE__*/React.createElement("div", _extends({
      role: "tooltip"
    }, styles('tooltip')), /*#__PURE__*/React.createElement("span", styles('tooltipLabel'), tooltipLabel), /*#__PURE__*/React.createElement("span", styles('tooltipHotKey'), tooltipKeyLabel)),
    position: popoverPosition,
    delayOpen: 1000,
    inline: !!fullscreen
  }, /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    small: small,
    active: active,
    onClick: onClick,
    style: styles,
    disabled: disabled
  }), icon && /*#__PURE__*/React.createElement(Icon$1, {
    icon: icon,
    inline: true
  }), children));
};
var defaultStyles$6 = function defaultStyles(_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font;
    _ref2.zIndex;
    var color = _ref2.color,
    size = _ref2.size;
    _ref2.spacing;
  return {
    border: '0',
    width: size.contentConsumptionToolbar.buttonSize,
    height: size.contentConsumptionToolbar.buttonSize,
    borderRadius: '2px',
    padding: '0',
    fontSize: '10px',
    fontWeight: 'normal',
    cursor: 'pointer',
    position: 'relative',
    color: color.text.base,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&active': {
      color: color.primary.base
    },
    '&fioriStyles': {
      borderRadius: '8px'
    },
    tooltip: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    },
    tooltipLabel: {
      fontSize: font.size.small
    },
    tooltipHotKey: {
      marginLeft: padding.small,
      color: color.text.inactive,
      fontSize: font.size.button
    }
  };
};
var PanAndZoomToolbarButton$1 = PanAndZoomToolbarButton;var useKeyboard = function useKeyboard() {
  var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useEffect(function () {
    if (!enabled) {
      return;
    }
    Object.entries(handlers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        handler = _ref2[1];
      Mousetrap.bind(key, handler);
    });
    return function () {
      Object.keys(handlers).forEach(function (key) {
        Mousetrap.unbind(key);
      });
    };
  }, [enabled, handlers]);
};var useDoubleClick = function useDoubleClick(_ref) {
  var doubleClick = _ref.doubleClick,
    click = _ref.click,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 200 : _ref$timeout;
  var clickTimeoutRef = useRef();
  var counterTimeoutRef = useRef();
  var countRef = useRef(0);
  var clearClickTimeout = function clearClickTimeout() {
    clearTimeout(clickTimeoutRef.current);
    clickTimeoutRef.current = undefined;
  };
  var clearCounterTimeout = function clearCounterTimeout() {
    clearTimeout(counterTimeoutRef.current);
    counterTimeoutRef.current = undefined;
  };
  return useCallback(function (event) {
    countRef.current++;
    clearClickTimeout();
    clearCounterTimeout();
    if (click && countRef.current === 1) {
      clickTimeoutRef.current = setTimeout(function () {
        click(event);
      }, timeout);
    }
    if (countRef.current % 2 === 0) {
      doubleClick(event);
    }
    counterTimeoutRef.current = setTimeout(function () {
      countRef.current = 0;
    }, timeout + 200);
  }, [click, doubleClick, timeout]);
};var zoomSlider$9 = "Zoom slider";
var fullscreen$9 = "Full screen";
var fit$8 = "Fit";
var zoom$a = "Zoom";
var zoomIn$9 = "Zoom in";
var zoomOut$9 = "Zoom out";
var toggleMinimap$9 = "Toggle mini map";
var zoomHintMac$9 = "To zoom the diagram, keep ⌘ pressed while scrolling";
var zoomHintWindows$9 = "To zoom the diagram, keep CTRL pressed while scrolling";
var en = {
	zoomSlider: zoomSlider$9,
	fullscreen: fullscreen$9,
	fit: fit$8,
	zoom: zoom$a,
	zoomIn: zoomIn$9,
	zoomOut: zoomOut$9,
	toggleMinimap: toggleMinimap$9,
	zoomHintMac: zoomHintMac$9,
	zoomHintWindows: zoomHintWindows$9
};var en$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$9,fullscreen:fullscreen$9,fit:fit$8,zoom:zoom$a,zoomIn:zoomIn$9,zoomOut:zoomOut$9,toggleMinimap:toggleMinimap$9,zoomHintMac:zoomHintMac$9,zoomHintWindows:zoomHintWindows$9,'default':en});var zoomSlider$8 = "Zoom-Schieberegler";
var fullscreen$8 = "Vollbild";
var fit$7 = "Anpassen";
var zoom$9 = "Zoom";
var zoomIn$8 = "Vergrößern";
var zoomOut$8 = "Verkleinern";
var toggleMinimap$8 = "Minikarte umschalten";
var zoomHintMac$8 = "Zum Zoomen des Diagramms ⌘ gedrückt halten und gleichzeitig scrollen";
var zoomHintWindows$8 = "Zum Zoomen des Diagramms STRG gedrückt halten und gleichzeitig scrollen";
var de = {
	zoomSlider: zoomSlider$8,
	fullscreen: fullscreen$8,
	fit: fit$7,
	zoom: zoom$9,
	zoomIn: zoomIn$8,
	zoomOut: zoomOut$8,
	toggleMinimap: toggleMinimap$8,
	zoomHintMac: zoomHintMac$8,
	zoomHintWindows: zoomHintWindows$8
};var de$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$8,fullscreen:fullscreen$8,fit:fit$7,zoom:zoom$9,zoomIn:zoomIn$8,zoomOut:zoomOut$8,toggleMinimap:toggleMinimap$8,zoomHintMac:zoomHintMac$8,zoomHintWindows:zoomHintWindows$8,'default':de});var zoomSlider$7 = "Regulador de zoom";
var fullscreen$7 = "Pantalla completa";
var fit$6 = "Ajustar";
var zoom$8 = "Hacer zoom";
var zoomIn$7 = "Ampliar";
var zoomOut$7 = "Alejar";
var toggleMinimap$7 = "Alternar minimapa";
var zoomHintMac$7 = "Para ampliar el diagrama, mantenga presionada la tecla ⌘ mientras se desplaza";
var zoomHintWindows$7 = "Para ampliar el diagrama, mantenga pulsada la tecla CTRL mientras se desplaza";
var es = {
	zoomSlider: zoomSlider$7,
	fullscreen: fullscreen$7,
	fit: fit$6,
	zoom: zoom$8,
	zoomIn: zoomIn$7,
	zoomOut: zoomOut$7,
	toggleMinimap: toggleMinimap$7,
	zoomHintMac: zoomHintMac$7,
	zoomHintWindows: zoomHintWindows$7
};var es$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$7,fullscreen:fullscreen$7,fit:fit$6,zoom:zoom$8,zoomIn:zoomIn$7,zoomOut:zoomOut$7,toggleMinimap:toggleMinimap$7,zoomHintMac:zoomHintMac$7,zoomHintWindows:zoomHintWindows$7,'default':es});var zoomSlider$6 = "Curseur de zoom";
var fullscreen$6 = "Plein écran";
var fit$5 = "Ajuster";
var zoom$7 = "Zoom";
var zoomIn$6 = "Zoom avant";
var zoomOut$6 = "Zoom arrière";
var toggleMinimap$6 = "Activer/Désactiver la mini-carte";
var zoomHintMac$6 = "Pour agrandir le diagramme, maintenez la touche ⌘ enfoncée tout en faisant défiler l’image";
var zoomHintWindows$6 = "Pour agrandir le diagramme, maintenez la touche CTRL enfoncée tout en faisant défiler l’image";
var fr = {
	zoomSlider: zoomSlider$6,
	fullscreen: fullscreen$6,
	fit: fit$5,
	zoom: zoom$7,
	zoomIn: zoomIn$6,
	zoomOut: zoomOut$6,
	toggleMinimap: toggleMinimap$6,
	zoomHintMac: zoomHintMac$6,
	zoomHintWindows: zoomHintWindows$6
};var fr$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$6,fullscreen:fullscreen$6,fit:fit$5,zoom:zoom$7,zoomIn:zoomIn$6,zoomOut:zoomOut$6,toggleMinimap:toggleMinimap$6,zoomHintMac:zoomHintMac$6,zoomHintWindows:zoomHintWindows$6,'default':fr});var zoomSlider$5 = "ズームスライダー";
var fullscreen$5 = "全画面";
var fit$4 = "合わせる";
var zoom$6 = "ズーム";
var zoomIn$5 = "ズームイン";
var zoomOut$5 = "ズームアウト";
var toggleMinimap$5 = "ミニマップの切り替え";
var zoomHintMac$5 = "ダイアグラムをズームするには、⌘ を押しながらスクロールしてください";
var zoomHintWindows$5 = "ダイアグラムをズームするには、CTRL を押しながらスクロールしてください";
var ja = {
	zoomSlider: zoomSlider$5,
	fullscreen: fullscreen$5,
	fit: fit$4,
	zoom: zoom$6,
	zoomIn: zoomIn$5,
	zoomOut: zoomOut$5,
	toggleMinimap: toggleMinimap$5,
	zoomHintMac: zoomHintMac$5,
	zoomHintWindows: zoomHintWindows$5
};var ja$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$5,fullscreen:fullscreen$5,fit:fit$4,zoom:zoom$6,zoomIn:zoomIn$5,zoomOut:zoomOut$5,toggleMinimap:toggleMinimap$5,zoomHintMac:zoomHintMac$5,zoomHintWindows:zoomHintWindows$5,'default':ja});var zoomSlider$4 = "확대/축소 슬라이더";
var fullscreen$4 = "전체 화면";
var fit$3 = "화면에 맞춤";
var zoom$5 = "확대/축소";
var zoomIn$4 = "확대";
var zoomOut$4 = "축소";
var toggleMinimap$4 = "미니 맵 토글";
var zoomHintMac$4 = "다이어그램을 확대하려면 스크롤하는 동안 ⌘ 모양을 누른 상태로 유지합니다";
var zoomHintWindows$4 = "다이어그램을 확대하려면 스크롤하는 동안 Ctrl 키를 누른 상태로 유지합니다";
var ko = {
	zoomSlider: zoomSlider$4,
	fullscreen: fullscreen$4,
	fit: fit$3,
	zoom: zoom$5,
	zoomIn: zoomIn$4,
	zoomOut: zoomOut$4,
	toggleMinimap: toggleMinimap$4,
	zoomHintMac: zoomHintMac$4,
	zoomHintWindows: zoomHintWindows$4
};var ko$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$4,fullscreen:fullscreen$4,fit:fit$3,zoom:zoom$5,zoomIn:zoomIn$4,zoomOut:zoomOut$4,toggleMinimap:toggleMinimap$4,zoomHintMac:zoomHintMac$4,zoomHintWindows:zoomHintWindows$4,'default':ko});var zoomSlider$3 = "Zoomschuifknop";
var fullscreen$3 = "Volledig scherm";
var fit$2 = "Aanpassen";
var zoom$4 = "Zoomen";
var zoomIn$3 = "Inzoomen";
var zoomOut$3 = "Uitzoomen";
var toggleMinimap$3 = "Minikaart inschakelen";
var zoomHintMac$3 = "Voor het zoomen van het diagram houdt u ⌘ ingedrukt terwijl u bladert";
var zoomHintWindows$3 = "Voor het zoomen van het diagram houdt u CTRL ingedrukt terwijl u bladert";
var nl = {
	zoomSlider: zoomSlider$3,
	fullscreen: fullscreen$3,
	fit: fit$2,
	zoom: zoom$4,
	zoomIn: zoomIn$3,
	zoomOut: zoomOut$3,
	toggleMinimap: toggleMinimap$3,
	zoomHintMac: zoomHintMac$3,
	zoomHintWindows: zoomHintWindows$3
};var nl$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$3,fullscreen:fullscreen$3,fit:fit$2,zoom:zoom$4,zoomIn:zoomIn$3,zoomOut:zoomOut$3,toggleMinimap:toggleMinimap$3,zoomHintMac:zoomHintMac$3,zoomHintWindows:zoomHintWindows$3,'default':nl});var zoomSlider$2 = "Controle deslizante de zoom";
var fullscreen$2 = "Tela cheia";
var zoom$3 = "Zoom";
var zoomIn$2 = "Ampliar";
var zoomOut$2 = "Reduzir";
var toggleMinimap$2 = "Alternar minimapa";
var zoomHintMac$2 = "Para ampliar o diagrama, mantenha ⌘ pressionado ao rolar";
var zoomHintWindows$2 = "Para ampliar o diagrama, mantenha CTRL pressionado ao rolar";
var pt = {
	zoomSlider: zoomSlider$2,
	fullscreen: fullscreen$2,
	zoom: zoom$3,
	zoomIn: zoomIn$2,
	zoomOut: zoomOut$2,
	toggleMinimap: toggleMinimap$2,
	zoomHintMac: zoomHintMac$2,
	zoomHintWindows: zoomHintWindows$2
};var pt$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$2,fullscreen:fullscreen$2,zoom:zoom$3,zoomIn:zoomIn$2,zoomOut:zoomOut$2,toggleMinimap:toggleMinimap$2,zoomHintMac:zoomHintMac$2,zoomHintWindows:zoomHintWindows$2,'default':pt});var zoomSlider$1 = "缩放滑块";
var fullscreen$1 = "全屏";
var fit$1 = "适应屏幕";
var zoom$2 = "缩放";
var zoomIn$1 = "放大";
var zoomOut$1 = "缩小";
var toggleMinimap$1 = "切换迷你地图";
var zoomHintMac$1 = "如需缩放图表，请在滚动时长按 ⌘";
var zoomHintWindows$1 = "如需缩放图表，请在滚动时长按 CTRL";
var zhCN = {
	zoomSlider: zoomSlider$1,
	fullscreen: fullscreen$1,
	fit: fit$1,
	zoom: zoom$2,
	zoomIn: zoomIn$1,
	zoomOut: zoomOut$1,
	toggleMinimap: toggleMinimap$1,
	zoomHintMac: zoomHintMac$1,
	zoomHintWindows: zoomHintWindows$1
};var zhCN$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider$1,fullscreen:fullscreen$1,fit:fit$1,zoom:zoom$2,zoomIn:zoomIn$1,zoomOut:zoomOut$1,toggleMinimap:toggleMinimap$1,zoomHintMac:zoomHintMac$1,zoomHintWindows:zoomHintWindows$1,'default':zhCN});var zoomSlider = "縮放滑桿";
var fullscreen = "全螢幕";
var fit = "最適大小";
var zoom$1 = "縮放";
var zoomIn = "放大";
var zoomOut = "縮小";
var toggleMinimap = "切換迷你圖";
var zoomHintMac = "若要縮放圖表，請於捲動時按住 ⌘";
var zoomHintWindows = "若要縮放圖表，請於捲動時按住 CTRL";
var zhTW = {
	zoomSlider: zoomSlider,
	fullscreen: fullscreen,
	fit: fit,
	zoom: zoom$1,
	zoomIn: zoomIn,
	zoomOut: zoomOut,
	toggleMinimap: toggleMinimap,
	zoomHintMac: zoomHintMac,
	zoomHintWindows: zoomHintWindows
};var zhTW$1=/*#__PURE__*/Object.freeze({__proto__:null,zoomSlider:zoomSlider,fullscreen:fullscreen,fit:fit,zoom:zoom$1,zoomIn:zoomIn,zoomOut:zoomOut,toggleMinimap:toggleMinimap,zoomHintMac:zoomHintMac,zoomHintWindows:zoomHintWindows,'default':zhTW});var FALLBACK_LOCALE = 'en_us';
var localeMap = {
  en_us: en$1,
  de_de: de$1,
  es_es: es$1,
  fr_fr: fr$1,
  ja_jp: ja$1,
  ko_kr: ko$1,
  nl_nl: nl$1,
  pt_pt: pt$1,
  zh_cn: zhCN$1,
  zh_tw: zhTW$1
};
var translate$1 = function translate(currentLocale) {
  var locale = currentLocale || FALLBACK_LOCALE;
  return function (label) {
    var _ref;
    var translatedLabel = localeMap[locale][label];
    return (_ref = translatedLabel !== null && translatedLabel !== void 0 ? translatedLabel : en$1[label]) !== null && _ref !== void 0 ? _ref : label;
  };
};
var useTranslate = function useTranslate(locale) {
  return useMemo(function () {
    return translate$1(locale);
  }, [locale]);
};var round = function round(number) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  return Math.round(number * units) / units;
};
var difference = function difference(a, b) {
  return Math.abs(a - b);
};
var distanceBetweenPoints = function distanceBetweenPoints(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y);
};
var getNearestValueIndex = function getNearestValueIndex(array, value) {
  return array.indexOf(array.reduce(function (p, n) {
    return Math.abs(p) > Math.abs(n - value) ? n - value : p;
  }, Infinity) + value);
};function PanAndZoomToolbar(_ref, ref) {
  var locale = _ref.locale,
    _ref$scale = _ref.scale,
    scale = _ref$scale === void 0 ? 0 : _ref$scale,
    _ref$maxScale = _ref.maxScale,
    maxScale = _ref$maxScale === void 0 ? 4 : _ref$maxScale,
    _ref$minScale = _ref.minScale,
    minScale = _ref$minScale === void 0 ? 0.1 : _ref$minScale,
    adjusting = _ref.adjusting,
    isIdle = _ref.isIdle,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right' : _ref$position,
    _ref$fullscreen = _ref.fullscreen,
    fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen,
    onToggleFullscreen = _ref.onToggleFullscreen,
    enableHotkeys = _ref.enableHotkeys,
    zoomMapToFit = _ref.zoomMapToFit,
    zoomMap = _ref.zoomMap,
    zoomOut = _ref.zoomOut,
    zoomIn = _ref.zoomIn,
    showMiniMap = _ref.showMiniMap,
    onToggleMiniMap = _ref.onToggleMiniMap,
    AdditionalToolbarItemsComponent = _ref.additionalToolbarItemsComponent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSliderVisible = _useState2[0],
    setIsSliderVisible = _useState2[1];
  var t = useTranslate(locale);
  var fioriStyles = useFioriStyles$1();
  var sliderRef = useRef(null);
  var sliderToggleRef = useRef(null);
  var zoomHybridClick = useDoubleClick({
    doubleClick: function doubleClick() {
      return zoomMap === null || zoomMap === void 0 ? void 0 : zoomMap(1);
    },
    click: function click() {
      !adjusting && setIsSliderVisible(!isSliderVisible);
    },
    timeout: 200
  });
  var isLeftPositionedControls = position === 'left';
  var popoverPosition = isLeftPositionedControls ? 'right' : 'left';
  var styles = useStyles$2(defaultStyles$5(fioriStyles), {
    fioriStyles: fioriStyles
  }, {
    '&leftPositionControls': !!isLeftPositionedControls,
    '&idleState': !!isIdle
  });
  var handleClickOutside = useCallback(function (event) {
    var _sliderRef$current, _sliderToggleRef$curr;
    var target = event.target;
    var hasClickedOnSlider = sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.contains(target);
    var hasClickedOnSliderToolbarButton = sliderToggleRef === null || sliderToggleRef === void 0 ? void 0 : (_sliderToggleRef$curr = sliderToggleRef.current) === null || _sliderToggleRef$curr === void 0 ? void 0 : _sliderToggleRef$curr.contains(target);
    if (!hasClickedOnSlider || !hasClickedOnSliderToolbarButton) {
      return;
    }
    setIsSliderVisible(false);
  }, [sliderRef, sliderToggleRef, setIsSliderVisible]);
  useEffect(function () {
    isSliderVisible ? document.addEventListener('mousedown', handleClickOutside) : document.removeEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, isSliderVisible]);
  var keyHandlers = useMemo(function () {
    return {
      f: function f() {
        return !fullscreen && (onToggleFullscreen === null || onToggleFullscreen === void 0 ? void 0 : onToggleFullscreen());
      },
      'shift+1': zoomMapToFit,
      'shift+0': function shift0() {
        return zoomMap === null || zoomMap === void 0 ? void 0 : zoomMap(1);
      },
      '+': zoomIn,
      '-': zoomOut,
      m: function m() {
        return onToggleMiniMap === null || onToggleMiniMap === void 0 ? void 0 : onToggleMiniMap();
      }
    };
  }, [zoomMapToFit, zoomIn, zoomOut, fullscreen, onToggleFullscreen, zoomMap, onToggleMiniMap]);
  useKeyboard(keyHandlers, enableHotkeys);
  return /*#__PURE__*/React.createElement("div", styles, isSliderVisible ? /*#__PURE__*/React.createElement("div", _extends({}, styles('sliderWrapper'), {
    ref: sliderRef
  }), /*#__PURE__*/React.createElement(Slider$1, {
    id: "zoomSlider",
    label: t('zoomSlider'),
    min: minScale * 100,
    max: maxScale * 100,
    value: scale * 100,
    step: 1,
    orient: 'vertical',
    size: 164,
    onChange: function onChange(_ref2) {
      var scale = _ref2.scale;
      return zoomMap === null || zoomMap === void 0 ? void 0 : zoomMap(scale / 100, false);
    }
  })) : null, /*#__PURE__*/React.createElement("div", _extends({}, styles('widgetWrapper'), {
    role: "toolbar",
    onMouseDown: function onMouseDown(event) {
      return event.stopPropagation();
    },
    ref: ref,
    "aria-label": isIdle ? 'idle toolbar' : 'non idle toolbar'
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxxsmall"
  }, onToggleFullscreen && /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    icon: fullscreen ? 'fullscreen-escape' : 'fullscreen-view',
    onClick: onToggleFullscreen,
    tooltipLabel: t('fullscreen'),
    tooltipKeyLabel: "F",
    "aria-label": fullscreen ? 'Close fullscreen' : 'Open fullscreen',
    popoverPosition: popoverPosition,
    fullscreen: fullscreen
  }), zoomMapToFit && /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    icon: "zoom-fit",
    onClick: zoomMapToFit,
    tooltipLabel: t('fit'),
    tooltipKeyLabel: "\u21E7 1",
    "aria-label": "Zoom to fit",
    popoverPosition: popoverPosition,
    fullscreen: fullscreen
  }), zoomMap && /*#__PURE__*/React.createElement("div", {
    ref: sliderToggleRef
  }, /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    onClick: zoomHybridClick,
    tooltipLabel: t('zoom'),
    tooltipKeyLabel: "\u21E7 ".concat(Math.round(minScale * 100), " - ").concat(Math.round(maxScale * 100), "%"),
    "aria-label": isSliderVisible ? 'Close zoom slider' : 'Open zoom slider',
    popoverPosition: popoverPosition,
    fullscreen: fullscreen
  }, isSliderVisible ? /*#__PURE__*/React.createElement("div", styles('arrowRotate'), "\u25BE") : null, /*#__PURE__*/React.createElement("div", null, "".concat(Math.round(scale * 100), "%")), isSliderVisible ? /*#__PURE__*/React.createElement("div", null, "\u25BE") : null)), zoomIn && /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    icon: "zoom",
    onClick: zoomIn,
    tooltipLabel: t('zoomIn'),
    tooltipKeyLabel: "\uFF0B",
    "aria-label": "Zoom in one step",
    popoverPosition: popoverPosition,
    fullscreen: fullscreen,
    disabled: round(scale, 100) === round(maxScale, 100)
  }), zoomOut && /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    icon: "zoom-out",
    onClick: zoomOut,
    tooltipLabel: t('zoomOut'),
    tooltipKeyLabel: "\u2212",
    "aria-label": "Zoom out one step",
    popoverPosition: popoverPosition,
    fullscreen: fullscreen,
    disabled: round(scale, 100) === round(minScale, 100)
  }), onToggleMiniMap && /*#__PURE__*/React.createElement(PanAndZoomToolbarButton$1, {
    icon: "minimap",
    onClick: onToggleMiniMap,
    tooltipLabel: t('toggleMinimap'),
    tooltipKeyLabel: "M",
    "aria-label": "Toggle mini map",
    active: showMiniMap,
    popoverPosition: popoverPosition,
    fullscreen: fullscreen
  }), AdditionalToolbarItemsComponent ? /*#__PURE__*/React.createElement(AdditionalToolbarItemsComponent, null) : null)));
}
var defaultStyles$5 = function defaultStyles(fioriStyles) {
  return function (_ref3) {
    var padding = _ref3.padding;
      _ref3.font;
      var color = _ref3.color,
      size = _ref3.size;
    return {
      position: 'relative',
      top: 0,
      width: 0,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      marginLeft: "calc(".concat(padding.xlarge, "px + ").concat(padding.normal, "px)"),
      '&leftPositionControls': {
        flexDirection: 'row-reverse',
        marginLeft: 'unset',
        marginRight: "calc(".concat(padding.xlarge, "px + ").concat(padding.normal, "px)"),
        sliderWrapper: {
          marginRight: 0,
          marginLeft: padding.xsmall
        }
      },
      sliderWrapper: {
        backgroundColor: color.surface,
        borderRadius: '2px',
        border: '1px solid rgba(0, 0, 0, 0.16)',
        marginRight: padding.xsmall
      },
      widgetWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: color.surface,
        borderRadius: fioriStyles ? '8px' : '2px',
        border: '1px solid rgba(0, 0, 0, 0.16)',
        boxShadow: '0px 1px 2px 1px rgb(0 0 0 / 16%), 0 0 1px 0 rgb(0 0 0 / 10%)',
        padding: padding.small,
        width: size.contentConsumptionToolbar.width
      },
      '&idleState': {
        opacity: 0.4,
        transition: 'all 0.3s'
      },
      arrowRotate: {
        transform: 'rotate(180deg) !important'
      }
    };
  };
};
var PanAndZoomToolbar$1 = /*#__PURE__*/forwardRef(PanAndZoomToolbar);var calculateHeight = function calculateHeight(fullscreen, customHeightOffset, customHeight) {
  if (!fullscreen && customHeight) {
    return "".concat(customHeight, "px");
  } else if (customHeightOffset) {
    return "calc(100vh - ".concat(customHeightOffset, "px)");
  }
  return;
};
var FullHeight = function FullHeight(_ref) {
  var fullscreen = _ref.fullscreen,
    offset = _ref.offset,
    children = _ref.children,
    customHeightOffset = _ref.customHeightOffset,
    customHeight = _ref.customHeight,
    _ref$heightOffset = _ref.heightOffset,
    heightOffset = _ref$heightOffset === void 0 ? 0 : _ref$heightOffset,
    _ref$heightMargins = _ref.heightMargins,
    heightMargins = _ref$heightMargins === void 0 ? 0 : _ref$heightMargins;
  var totalHeightOffset = heightOffset + heightMargins;
  var styles = useStyles$2(defaultStyles$4(totalHeightOffset), {}, {
    '&fullscreenContainer': fullscreen || !!offset,
    '&offset': !!offset,
    '&fullscreen': !!fullscreen
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "full-height"
  }, inline(styles, {
    height: calculateHeight(fullscreen, customHeightOffset, customHeight)
  })), children);
};
var defaultStyles$4 = function defaultStyles(totalHeightOffset) {
  return function () {
    return {
      minHeight: '150px',
      height: "calc(100vh - ".concat(totalHeightOffset, "px)"),
      position: 'relative',
      '&fullscreenContainer': {
        position: 'absolute',
        top: 72 /* sticky header */,
        left: 0,
        bottom: 0,
        right: 0
      },
      '&fullscreen': {
        height: 'calc(100vh - 76px)'
      },
      '&offset': {
        height: 'calc(100vh - 114px)'
      }
    };
  };
};
var FullHeight$1 = FullHeight;var ZoomHint = function ZoomHint(_ref) {
  var visible = _ref.visible,
    locale = _ref.locale;
  var t = useTranslate(locale);
  var styles = useStyles$2(defaultStyles$3, {}, {
    '&visible': visible
  });
  var isMac = useMemo(function () {
    return navigator.platform.toUpperCase().includes('MAC');
  }, []);
  return /*#__PURE__*/React.createElement("div", styles, isMac ? t('zoomHintMac') : t('zoomHintWindows'));
};
var defaultStyles$3 = function defaultStyles(_ref2) {
  var padding = _ref2.padding,
    zIndex = _ref2.zIndex;
  return {
    fontSize: 14,
    position: 'absolute',
    pointerEvents: 'none',
    padding: "".concat(padding.small, "px ").concat(padding.normal, "px"),
    bottom: padding.normal,
    left: '50%',
    height: '40px',
    whiteSpace: 'nowrap',
    transform: 'translateX(-50%)',
    color: 'white',
    opacity: 0,
    borderRadius: '2px',
    transition: 'all ease-in-out 0.2s',
    backgroundColor: 'rgba(51, 51, 51, 0.9)',
    textAlign: 'center',
    zIndex: zIndex.toast,
    '&visible': {
      bottom: '24px',
      opacity: 1
    }
  };
};
var ZoomHint$1 = ZoomHint;// This hook binds the mouse event handlers to window & the passed containerElement.
// It doesn't require referential stability of handlers and will only re-register listeners
// if the identity of containerElement changes.
var useMouseEvents = function useMouseEvents(containerElement, handlers) {
  var handlersRef = useRef(handlers);
  useEffect(function () {
    handlersRef.current = handlers;
  });
  useEffect(function () {
    var handleDrag = function handleDrag(ev) {
      return handlersRef.current.handleDrag(ev);
    };
    var handleRelease = function handleRelease(ev) {
      return handlersRef.current.handleRelease(ev);
    };
    var handleTouchMove = function handleTouchMove(ev) {
      return handlersRef.current.handleTouchMove(ev);
    };
    window.addEventListener('mousemove', handleDrag);
    window.addEventListener('mouseup', handleRelease);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleRelease);
    return function () {
      window.removeEventListener('mousemove', handleDrag);
      window.removeEventListener('mouseup', handleRelease);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleRelease);
    };
  }, []);
  useEffect(function () {
    if (!containerElement) return;
    var handleWheel = function handleWheel(ev) {
      return handlersRef.current.handleWheel(ev);
    };

    /*
      wheel events on chrome (>=73) are passive by default,
      passive flag is not yet configurable for react event handler
      (https://github.com/facebook/react/issues/14856)
    */
    containerElement.addEventListener('wheel', handleWheel, {
      passive: false
    });
    return function () {
      containerElement.removeEventListener('wheel', handleWheel);
    };
  }, [containerElement]);
};
var useMouseEvents$1 = useMouseEvents;var SAFE_MARGIN = 10;
var usePanAndZoomStickyStyles = function usePanAndZoomStickyStyles(_ref) {
  var containerRef = _ref.containerRef,
    stickyContainerSelector = _ref.stickyContainerSelector,
    enabled = _ref.enabled,
    _ref$topMargin = _ref.topMargin,
    topMargin = _ref$topMargin === void 0 ? 0 : _ref$topMargin,
    _ref$extraTopOffset = _ref.extraTopOffset,
    extraTopOffset = _ref$extraTopOffset === void 0 ? 0 : _ref$extraTopOffset,
    showMiniMap = _ref.showMiniMap,
    toolbarRef = _ref.toolbarRef;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollTop = _useState2[0],
    setScrollTop = _useState2[1];
  var _useState3 = useState(extraTopOffset),
    _useState4 = _slicedToArray(_useState3, 2),
    topOffset = _useState4[0],
    setTopOffset = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    panZoomToolbarHeight = _useState6[0],
    setPanZoomToolbarHeight = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    scrollableHeight = _useState8[0],
    setScrollableHeight = _useState8[1];
  var _useResizeObserver = useResizeObserver(containerRef),
    _useResizeObserver2 = _slicedToArray(_useResizeObserver, 2),
    containerHeight = _useResizeObserver2[1];
  useEffect(function () {
    var _toolbarRef$current;
    if (!(toolbarRef !== null && toolbarRef !== void 0 && toolbarRef.current)) return undefined;
    var _toolbarRef$current$g = toolbarRef === null || toolbarRef === void 0 ? void 0 : (_toolbarRef$current = toolbarRef.current) === null || _toolbarRef$current === void 0 ? void 0 : _toolbarRef$current.getBoundingClientRect(),
      height = _toolbarRef$current$g.height;
    setPanZoomToolbarHeight(height + 2); // 2px margin to apply shadow effect correctly
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolbarRef.current]);
  var onScroll = useCallback(function (e) {
    var _document, _stickyContainer$getB;
    if (!stickyContainerSelector) return;
    var stickyContainer = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector(stickyContainerSelector);
    var scrollTop = stickyContainer === null || stickyContainer === void 0 ? void 0 : stickyContainer.scrollTop;
    var top = stickyContainer === null || stickyContainer === void 0 ? void 0 : (_stickyContainer$getB = stickyContainer.getBoundingClientRect()) === null || _stickyContainer$getB === void 0 ? void 0 : _stickyContainer$getB.top;
    if (top) setTopOffset(top + extraTopOffset);
    if (scrollTop) setScrollTop(scrollTop);
  }, [extraTopOffset, stickyContainerSelector]);

  // Very small debounce wait value to reduce the calls to onScroll
  // and still keep a smooth sticky behaviour
  var onScrollDebounced = useDebouncedCallback(onScroll, 10);

  // Add the scroll event listener to the stickyContainerSelector dom
  useEffect(function () {
    if (!panZoomToolbarHeight || !enabled || !stickyContainerSelector) return;
    var stickyContainer = document.querySelector(stickyContainerSelector);
    if (stickyContainer) {
      var _stickyContainer$getB2 = stickyContainer.getBoundingClientRect(),
        top = _stickyContainer$getB2.top;
      setTopOffset(top + extraTopOffset);
      stickyContainer.addEventListener('scroll', onScrollDebounced, false);

      /**
       * Listen to changes to stickyContainer.scrollHeight
       * This is required to force a recalculation in case the scrollable container
       * height has changed.
       */
      var observer = new ResizeObserver(function () {
        setScrollableHeight(stickyContainer.scrollHeight);
      });

      // observe the size of all stickyContainer children
      Array.from(stickyContainer.children).forEach(function (element) {
        observer.observe(element);
      });
      return function () {
        observer.disconnect();
        stickyContainer.removeEventListener('scroll', onScrollDebounced, false);
      };
    }
  }, [stickyContainerSelector, enabled, onScrollDebounced, extraTopOffset, panZoomToolbarHeight]);

  // Calculate top and height values in order to keep the toolbar and minimap container sticky in viewport
  var getStickyStyles = useCallback(function () {
    var _containerRef$current;
    if (!enabled) {
      return {};
    }
    var _ref2 = (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect()) || {},
      containerTop = _ref2.top;
    var currentContainerTop = containerTop + scrollTop;
    var diff = scrollTop - (currentContainerTop - topOffset);
    var stickyTop = diff > 0 ? diff : 0;
    var height;
    // If minimap is displayed we need to get the height of the displayed part of the diagram card
    // Otherwise height of the container is the height of the pan and zoom toolbar
    if (showMiniMap) {
      height = diff > 0 ? window.innerHeight - topOffset - topMargin - SAFE_MARGIN : window.innerHeight + scrollTop - currentContainerTop - topMargin - SAFE_MARGIN;
    } else {
      height = panZoomToolbarHeight + SAFE_MARGIN;
    }

    /*
      If the height of the toolbar + minimap added to top position exceed the containerHeight,
      the height should shrink to stay sticky in the viewport
    */
    if (containerHeight && stickyTop + height > containerHeight) {
      var newContainerHeight = containerHeight - (stickyTop + SAFE_MARGIN);
      var newHeight = newContainerHeight > panZoomToolbarHeight ? newContainerHeight : panZoomToolbarHeight;
      var top = containerHeight - newHeight;
      return {
        top: top,
        height: newHeight
      };
    } else {
      return {
        top: stickyTop + topMargin,
        height: height
      };
    }
    // scrollableHeight state tracks changes in the scrollable container height and force a re-calculation when it changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerHeight, scrollableHeight, enabled, panZoomToolbarHeight, scrollTop, showMiniMap, topMargin, topOffset]);
  return {
    getStickyStyles: getStickyStyles
  };
};
var usePanAndZoomStickyStyles$1 = usePanAndZoomStickyStyles;var MOUSE_HOVER_RADIUS = 32;
var calcMaxHeight = function calcMaxHeight() {
  var _document$documentEle;
  var heightOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.max(((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientHeight) || 0, window.innerHeight || 0) - heightOffset;
};
var isControlIdle = function isControlIdle(e, ref) {
  var _ref$current;
  var clientX = e.clientX,
    clientY = e.clientY;
  var _ref = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect()) || {},
    _ref$left = _ref.left,
    x = _ref$left === void 0 ? 0 : _ref$left,
    _ref$top = _ref.top,
    y = _ref$top === void 0 ? 0 : _ref$top,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height;
  return !(clientX > x - MOUSE_HOVER_RADIUS && clientX < x + width + MOUSE_HOVER_RADIUS && clientY > y - MOUSE_HOVER_RADIUS && clientY < y + height + MOUSE_HOVER_RADIUS);
};function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MAX_SCALE = 5;
var INITIAL_SCALE = 1;

// The bounding rect coordinates are **absolute** (relative to the same origin) for
// both, container and content. However, the return value of this function is the
// new content translation **relative** to the container rect.
function drag(_ref) {
  var containerRect = _ref.containerRect,
    contentRect = _ref.contentRect,
    deltaX = _ref.deltaX,
    deltaY = _ref.deltaY;
  var _translate = translate(containerRect, contentRect),
    translateX = _translate.translateX,
    translateY = _translate.translateY;
  /*
   * Drag and move the content using CSS translate.
   */
  var _safeMove = safeMove(containerRect, contentRect, deltaX, deltaY),
    adjustedDeltaX = _safeMove.deltaX,
    adjustedDeltaY = _safeMove.deltaY;
  return {
    translateX: round(translateX + adjustedDeltaX),
    translateY: round(translateY + adjustedDeltaY)
  };
}
function zoom(_ref2) {
  var containerRect = _ref2.containerRect,
    contentRect = _ref2.contentRect,
    scale = _ref2.scale,
    _ref2$minScale = _ref2.minScale,
    minScale = _ref2$minScale === void 0 ? 0.1 : _ref2$minScale,
    zoomDelta = _ref2.zoomDelta,
    originX = _ref2.originX,
    originY = _ref2.originY,
    fullscreen = _ref2.fullscreen,
    _ref2$zoomToFit = _ref2.zoomToFit,
    zoomToFit = _ref2$zoomToFit === void 0 ? false : _ref2$zoomToFit;
  /*
   * Get the next scale, and adjust translate to provide the illusion of a
   * gmaps style zoom around current mouse position
   */

  var nextScale = scale + zoomDelta;
  var width = contentRect.width;
  var height = contentRect.height;

  // the fitting scale, content to container
  nextScale = Math.min(nextScale, MAX_SCALE);
  nextScale = nextScale < minScale ? minScale : nextScale;
  var nextContentRect = scaleRectangle(contentRect, scale, nextScale);
  var _ref3 = zoomToFit ? align(containerRect, nextContentRect, fullscreen) : translate(containerRect, contentRect),
    translateX = _ref3.translateX,
    translateY = _ref3.translateY;

  // calculate the new width after the scale step is applied
  var nextWidth = nextContentRect.width;
  var nextHeight = nextContentRect.height;

  // pixel delta, mouse position to picture origin
  var offsetX = originX - contentRect.left;
  var offsetY = originY - contentRect.top;

  // percentage delta, mouse position to picture origin
  var offsetRatioX = offsetX / width;
  var offsetRatioY = offsetY / height;

  // growth delta in pixels
  var growthDeltaX = -1 * (nextWidth - width);
  var growthDeltaY = -1 * (nextHeight - height);

  /*
   * In order to keep the illusion of zooming around the mouse position,
   * we need to move the content by:
   * The percentual mouse position -> get that slice from growthDelta ->
   * -> move the pic by that
   */
  var deltaX = growthDeltaX * offsetRatioX;
  var deltaY = growthDeltaY * offsetRatioY;
  return {
    scale: round(nextScale),
    translateX: round(translateX + deltaX),
    translateY: round(translateY + deltaY)
  };
}
function reset(_ref4) {
  var containerRect = _ref4.containerRect,
    contentRect = _ref4.contentRect,
    scale = _ref4.scale,
    fullscreen = _ref4.fullscreen,
    maxHeight = _ref4.maxHeight,
    zoomToFit = _ref4.zoomToFit,
    fitContentWidth = _ref4.fitContentWidth;
  var fittedScale = round(fittingScale({
    containerRect: containerRect,
    contentRect: contentRect,
    scale: scale,
    maxHeight: maxHeight,
    fitContentWidth: fitContentWidth
  }));
  var nextScale = zoomToFit && fittedScale < 1 ? fittedScale : 1;
  var nextContentRect = scaleRectangle(contentRect, scale, nextScale);
  var nextHeight = proportionalHeight(containerRect, nextContentRect);
  var _align = align(containerRect, nextContentRect, fullscreen),
    translateX = _align.translateX,
    translateY = _align.translateY;
  return _objectSpread$1({
    scale: nextScale,
    translateX: round(translateX),
    translateY: round(translateY)
  }, fullscreen ? {} : {
    height: round(nextHeight)
  });
}
function align(containerRect, contentRect, fullscreen) {
  var _translate2 = translate(containerRect, contentRect),
    translateX = _translate2.translateX,
    translateY = _translate2.translateY;
  var _alignmentRectangle = alignmentRectangle(containerRect, contentRect, fullscreen),
    top = _alignmentRectangle.top,
    left = _alignmentRectangle.left,
    right = _alignmentRectangle.right,
    bottom = _alignmentRectangle.bottom;
  var deltaX = 0;
  if (contentRect.left > left) {
    deltaX -= contentRect.left - left;
  }
  if (contentRect.right < right) {
    deltaX += right - contentRect.right;
  }
  var deltaY = 0;
  if (contentRect.top > top) {
    deltaY -= contentRect.top - top;
  }
  if (contentRect.bottom < bottom) {
    deltaY += bottom - contentRect.bottom;
  }
  return _objectSpread$1({
    translateX: round(translateX + deltaX),
    translateY: round(translateY + deltaY)
  }, fullscreen ? {} : {
    height: zoomedHeight(contentRect, translateY + deltaY)
  });
}
function zoomAndCenter(_ref5) {
  var containerRect = _ref5.containerRect,
    contentRect = _ref5.contentRect,
    relativeRect = _ref5.relativeRect,
    scale = _ref5.scale,
    nextScale = _ref5.nextScale;
  var _translate3 = translate(containerRect, contentRect),
    translateX = _translate3.translateX,
    translateY = _translate3.translateY;
  var nextContentRect = scaleRectangle(contentRect, scale, nextScale);
  var targetRect = moveRectangle(scaleRectangle(relativeRect, INITIAL_SCALE, nextScale, true), translateX, translateY);
  if (targetRect.width > containerRect.width || targetRect.height > containerRect.height) {
    return {
      scale: scale,
      translateX: translateX,
      translateY: translateY
    };
  }
  var deltaX = (containerRect.width - targetRect.width) / 2 - targetRect.left;
  var deltaY = (containerRect.height - targetRect.height) / 2 - targetRect.top;
  var _safeMove2 = safeMove(containerRect, nextContentRect, deltaX, deltaY),
    adjustedDeltaX = _safeMove2.deltaX,
    adjustedDeltaY = _safeMove2.deltaY;
  return {
    scale: nextScale,
    translateX: round(translateX + adjustedDeltaX),
    translateY: round(translateY + adjustedDeltaY)
  };
}
function alignmentRectangle(containerRect, contentRect, fullscreen) {
  if (fullscreen) {
    // centered
    return {
      top: containerRect.top + (containerRect.height - Math.min(contentRect.height, containerRect.height)) / 2,
      bottom: containerRect.bottom - (containerRect.height - Math.min(contentRect.height, containerRect.height)) / 2,
      left: containerRect.left + (containerRect.width - Math.min(contentRect.width, containerRect.width)) / 2,
      right: containerRect.right - (containerRect.width - Math.min(contentRect.width, containerRect.width)) / 2
    };
  } else {
    // upper left corner
    return {
      top: containerRect.top,
      bottom: containerRect.bottom - (containerRect.height - Math.min(contentRect.height, containerRect.height)),
      left: containerRect.left,
      right: containerRect.right - (containerRect.width - Math.min(contentRect.width, containerRect.width))
    };
  }
}
function scaleRectangle(rectangle, scale, nextScale) {
  var centered = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var width = rectangle.width || rectangle.right - rectangle.left;
  var height = rectangle.height || rectangle.bottom - rectangle.top;
  var nextWidth = width / scale * nextScale;
  var nextHeight = height / scale * nextScale;
  return centered ? {
    top: rectangle.top / scale * nextScale,
    bottom: rectangle.bottom / scale * nextScale,
    left: rectangle.left / scale * nextScale,
    right: rectangle.right / scale * nextScale,
    height: nextHeight,
    width: nextWidth
  } : {
    top: rectangle.top,
    bottom: rectangle.top + nextHeight,
    left: rectangle.left,
    right: rectangle.left + nextWidth,
    height: nextHeight,
    width: nextWidth
  };
}
function moveRectangle(rectangle, deltaX, deltaY) {
  return _objectSpread$1(_objectSpread$1({}, rectangle), {}, {
    left: rectangle.left + deltaX,
    right: rectangle.right + deltaX,
    top: rectangle.top + deltaY,
    bottom: rectangle.bottom + deltaY
  });
}
function proportionalHeight(containerRect, contentRect) {
  return Math.min(containerRect.width * (contentRect.height / contentRect.width), contentRect.height);
}
function zoomedHeight(contentRect, translateY) {
  return contentRect.height + translateY;
}
function translate(containerRect, contentRect) {
  return {
    translateX: contentRect.left - containerRect.left,
    translateY: contentRect.top - containerRect.top
  };
}
function fittingScale(_ref7) {
  var containerRect = _ref7.containerRect,
    contentRect = _ref7.contentRect,
    scale = _ref7.scale,
    _ref7$maxHeight = _ref7.maxHeight,
    maxHeight = _ref7$maxHeight === void 0 ? Infinity : _ref7$maxHeight,
    _ref7$fitContentWidth = _ref7.fitContentWidth,
    fitContentWidth = _ref7$fitContentWidth === void 0 ? false : _ref7$fitContentWidth;
  if (fitContentWidth) {
    // reset it to INITIAL_SCALE or width scale
    return Math.min(containerRect.width / (contentRect.width / scale), INITIAL_SCALE);
  }

  // reset it to INITIAL_SCALE or smaller, a scale that fits the container
  return Math.min(containerRect.width / (contentRect.width / scale), maxHeight / (contentRect.height / scale), INITIAL_SCALE);
}
function safeMove(containerRect, contentRect, deltaX, deltaY) {
  var adjustedDeltaX = 0;
  var horizontalMargin = Math.max(containerRect.width / 2, containerRect.width - contentRect.width);
  var verticalMargin = Math.max(containerRect.height / 2, containerRect.height - contentRect.height);
  var marginedContentRect = {
    right: contentRect.right + horizontalMargin,
    left: contentRect.left - horizontalMargin,
    top: contentRect.top - verticalMargin,
    bottom: contentRect.bottom + verticalMargin
  };
  var canMoveLeft = deltaX < 0 && marginedContentRect.right > containerRect.right;
  if (canMoveLeft) {
    adjustedDeltaX = Math.abs(deltaX) > marginedContentRect.right - containerRect.right ? containerRect.right - marginedContentRect.right : deltaX;
  }
  var canMoveRight = deltaX > 0 && containerRect.left > marginedContentRect.left;
  if (canMoveRight) {
    adjustedDeltaX = deltaX > containerRect.left - marginedContentRect.left ? containerRect.left - marginedContentRect.left : deltaX;
  }
  var adjustedDeltaY = 0;
  var canMoveUp = deltaY < 0 && marginedContentRect.bottom > containerRect.bottom;
  if (canMoveUp) {
    adjustedDeltaY = Math.abs(deltaY) > marginedContentRect.bottom - containerRect.bottom ? containerRect.bottom - marginedContentRect.bottom : deltaY;
  }
  var canMoveDown = deltaY > 0 && containerRect.top > marginedContentRect.top;
  if (canMoveDown) {
    adjustedDeltaY = deltaY > containerRect.top - marginedContentRect.top ? containerRect.top - marginedContentRect.top : deltaY;
  }
  return {
    deltaX: adjustedDeltaX,
    deltaY: adjustedDeltaY
  };
}function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SCALE_STEPS = [4, 2, 1.5, 1, 0.75, 0.5, 0.25, 0.1];
var MINI_MAP_WIDTH = 264;
var MINI_MAP_HEIGHT = 164;
var updateScaleStepsByMinScale = function updateScaleStepsByMinScale(minScale) {
  var closestValueIndex = getNearestValueIndex(SCALE_STEPS, minScale);
  return [].concat(_toConsumableArray(SCALE_STEPS.slice(0, closestValueIndex)), [minScale]);
};
var stickyToolsDefault = {
  enabled: false,
  stickyContainerSelector: ''
};
var initialPositionFallback = {
  x: 0,
  y: 0
};
var defaultPosition = {
  x: undefined,
  y: undefined
};
function PanAndZoom(_ref, forwardedRef) {
  var _containerRef$current8;
  var locale = _ref.locale,
    children = _ref.children,
    fullscreen = _ref.inFullscreenMode,
    offset = _ref.offset,
    zoomWithMetaKey = _ref.zoomWithMetaKey,
    onToggleFullscreen = _ref.onToggleFullscreen,
    zoomToFit = _ref.zoomToFit,
    additionalToolbarItemsComponent = _ref.additionalToolbarItemsComponent,
    _ref$zoomToFitOnStart = _ref.zoomToFitOnStart,
    zoomToFitOnStart = _ref$zoomToFitOnStart === void 0 ? false : _ref$zoomToFitOnStart,
    customHeightOffset = _ref.customHeightOffset,
    toolbarRef = _ref.toolbarRef,
    miniMapSvg = _ref.miniMapSvg,
    fitContentWidth = _ref.fitContentWidth,
    onToggleMiniMap = _ref.onToggleMiniMap,
    _ref$isMiniMapOn = _ref.isMiniMapOn,
    isMiniMapOn = _ref$isMiniMapOn === void 0 ? true : _ref$isMiniMapOn,
    _ref$fitContentHeight = _ref.fitContentHeight,
    fitContentHeight = _ref$fitContentHeight === void 0 ? false : _ref$fitContentHeight,
    AdditionalContentComponent = _ref.fullscreenAdditionalContent,
    idleEnabled = _ref.idleEnabled,
    _ref$controlsPosition = _ref.controlsPosition,
    controlsPosition = _ref$controlsPosition === void 0 ? 'right' : _ref$controlsPosition,
    initialScale = _ref.initialScale,
    _ref$initialPosition = _ref.initialPosition,
    initialPosition = _ref$initialPosition === void 0 ? initialPositionFallback : _ref$initialPosition,
    onDragStart = _ref.onDragStart,
    onDragStop = _ref.onDragStop,
    _ref$heightOffset = _ref.heightOffset,
    heightOffset = _ref$heightOffset === void 0 ? 0 : _ref$heightOffset,
    _ref$heightMargins = _ref.heightMargins,
    heightMargins = _ref$heightMargins === void 0 ? 0 : _ref$heightMargins,
    _ref$notPrintableClas = _ref.notPrintableClassName,
    notPrintableClassName = _ref$notPrintableClas === void 0 ? 'not-printable' : _ref$notPrintableClas;
  invariant(!forwardedRef || typeof forwardedRef !== 'function', 'Callback refs are not supported');
  var internalRef = useRef(null);
  var containerRef = forwardedRef || internalRef;
  var hasResetScaleBeenCalledRef = useRef(null);
  var defaultToolbarRef = useRef(null);
  var toolbarReference = toolbarRef || defaultToolbarRef;
  var minimapReference = useRef(null);
  var additionalContentReference = useRef(null);
  var didFullheightSetupRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    contentElement = _useState2[0],
    setContentElement = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    grabbing = _useState4[0],
    setGrabbing = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    moving = _useState6[0],
    setMoving = _useState6[1];
  var _useState7 = useState(defaultPosition),
    _useState8 = _slicedToArray(_useState7, 2),
    lastPosition = _useState8[0],
    setLastPosition = _useState8[1];
  var _useState9 = useState(defaultPosition),
    _useState10 = _slicedToArray(_useState9, 2),
    grabPosition = _useState10[0],
    setGrabPosition = _useState10[1];
  var _useState11 = useState(1),
    _useState12 = _slicedToArray(_useState11, 2),
    scale = _useState12[0],
    setScale = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    distance = _useState14[0],
    setDistance = _useState14[1];
  var _useState15 = useState({
      x: 0,
      y: 0
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    translate = _useState16[0],
    setTranslate = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isHoveringContainer = _useState18[0],
    setIsHoveringContainer = _useState18[1];
  var _useState19 = useState(isMiniMapOn),
    _useState20 = _slicedToArray(_useState19, 2),
    showMiniMap = _useState20[0],
    setShowMiniMap = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    customHeight = _useState22[0],
    setCustomHeight = _useState22[1];
  var _useState23 = useState(SCALE_STEPS[SCALE_STEPS.length - 1]),
    _useState24 = _slicedToArray(_useState23, 2),
    minScale = _useState24[0],
    setMinScale = _useState24[1];
  var scaleSteps = useRef(SCALE_STEPS);
  var tX = offset ? offset.deltaX + translate.x : translate.x;
  var tY = offset ? offset.deltaY + translate.y : translate.y;
  var toggleMiniMap = useCallback(function () {
    if (miniMapSvg) {
      setShowMiniMap(function (state) {
        onToggleMiniMap === null || onToggleMiniMap === void 0 ? void 0 : onToggleMiniMap(!state);
        return !state;
      });
    }
  }, [miniMapSvg, onToggleMiniMap]);

  // Adjusting means that an animated auto-adjustment is going on.
  // The state is automatically cleared after 300ms (by then the animation has finished).
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    adjusting = _useState26[0],
    setAdjusting = _useState26[1];
  useEffect(function () {
    if (!adjusting) return;
    var timeout = window.setTimeout(function () {
      setAdjusting(false);
    }, 300);
    return function () {
      window.clearTimeout(timeout);
    };
  }, [adjusting]);

  // When using the scroll wheel we show a hint about zooming, this state toggles it.
  // The hint shall disappear after 2s
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showZoomHint = _useState28[0],
    setShowZoomHint = _useState28[1];
  useEffect(function () {
    if (!showZoomHint) return;
    var timeout = window.setTimeout(function () {
      setShowZoomHint(false);
    }, 2000);
    return function () {
      window.clearTimeout(timeout);
    };
  }, [showZoomHint]);

  // Set zoom & scroll to default initial state
  var resetToInitial = function resetToInitial() {
    var _containerRef$current;
    var fitContentWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _reset = reset({
        containerRect: (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect(),
        contentRect: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
        scale: scale,
        fullscreen: fullscreen,
        maxHeight: calcMaxHeight(heightOffset),
        zoomToFit: zoomToFit,
        fitContentWidth: fitContentWidth
      }),
      newScale = _reset.scale,
      translateX = _reset.translateX,
      translateY = _reset.translateY;
    if (initialPosition.x || initialPosition.y) {
      var scaleToUse = initialScale ? initialScale : newScale;
      var _getTranslateInBounda = getTranslateInBoundaries(initialPosition),
        x = _getTranslateInBounda.x,
        y = _getTranslateInBounda.y;
      setScale(scaleToUse);
      setTranslate({
        x: x * scaleToUse,
        y: y * scaleToUse
      });
    } else {
      setScale(newScale);
      setTranslate({
        x: translateX,
        y: translateY
      });
    }
    if (fitContentWidth) {
      setMinScale(newScale);
      scaleSteps.current = updateScaleStepsByMinScale(newScale);
    }
  };
  var getTranslateInBoundaries = function getTranslateInBoundaries(_ref2) {
    var _containerRef$current2;
    var _ref2$x = _ref2.x,
      x = _ref2$x === void 0 ? 0 : _ref2$x,
      _ref2$y = _ref2.y,
      y = _ref2$y === void 0 ? 0 : _ref2$y;
    var containerRect = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.getBoundingClientRect();
    var contentRect = contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect();
    var isInBoundaries = containerRect && x >= 0 && x <= containerRect.width && y >= 0 && y <= containerRect.height;
    if (isInBoundaries) {
      return {
        x: -x,
        y: -y
      };
    }

    // centering if out of boundaries
    var _zoomAndCenter = zoomAndCenter({
        containerRect: containerRect,
        contentRect: contentRect,
        relativeRect: containerRect,
        scale: 1,
        nextScale: 1
      }),
      translateX = _zoomAndCenter.translateX,
      translateY = _zoomAndCenter.translateY;
    return {
      x: translateX,
      y: translateY
    };
  };

  // debouncedAlignMap shall be called when toggling fullscreen on or off.
  // It aligns the diagram to the top left in the card and centers it in fullscreen after a 500ms delay
  var alignMap = useCallback(function (_ref3) {
    var fullscreen = _ref3.fullscreen;
    setAdjusting(true);
    if (containerRef.current && contentElement) {
      var _align = align(containerRef.current.getBoundingClientRect(), contentElement.getBoundingClientRect(), fullscreen),
        translateX = _align.translateX,
        translateY = _align.translateY;
      setTranslate({
        x: translateX,
        y: translateY
      });
    }
  }, [containerRef, contentElement]);
  var debouncedAlignMap = useDebouncedCallback(alignMap, 500);
  var handleScale = useCallback(function (_ref4) {
    var zoomDelta = _ref4.zoomDelta,
      _ref4$zoomToFit = _ref4.zoomToFit,
      zoomToFit = _ref4$zoomToFit === void 0 ? false : _ref4$zoomToFit,
      _ref4$waitForAdjustme = _ref4.waitForAdjustment,
      waitForAdjustment = _ref4$waitForAdjustme === void 0 ? false : _ref4$waitForAdjustme;
    if (containerRef.current && contentElement) {
      var containerRect = containerRef.current.getBoundingClientRect();
      var contentRect = contentElement.getBoundingClientRect();
      if (waitForAdjustment) setAdjusting(true);
      var originX = zoomToFit ? contentRect.left : containerRect.left + containerRect.width / 2;
      var originY = zoomToFit ? contentRect.top : containerRect.top + containerRect.height / 2;
      var _zoom = zoom({
          containerRect: containerRect,
          contentRect: contentRect,
          scale: scale,
          minScale: minScale,
          zoomDelta: zoomDelta,
          originX: originX,
          originY: originY,
          fullscreen: fullscreen,
          maxHeight: calcMaxHeight(heightOffset),
          zoomToFit: zoomToFit
        }),
        newScale = _zoom.scale,
        translateX = _zoom.translateX,
        translateY = _zoom.translateY;
      setScale(newScale);
      setTranslate({
        x: translateX,
        y: translateY
      });
    }
  }, [containerRef, contentElement, fullscreen, heightOffset, minScale, scale]);
  var handleScaleButton = useCallback(function (up) {
    var nearestValueIndex = getNearestValueIndex(scaleSteps.current, scale);
    var zoomDelta;
    if (up) {
      var isMinScale = nearestValueIndex - 1 < 0;
      var prevScaleIndex = isMinScale ? 0 : nearestValueIndex - 1;
      zoomDelta = round(difference(scale, scaleSteps.current[prevScaleIndex]));
    } else {
      var isMaxScale = nearestValueIndex + 1 >= scaleSteps.current.length;
      var nextScaleIndex = isMaxScale ? nearestValueIndex : nearestValueIndex + 1;
      zoomDelta = round(-difference(scale, scaleSteps.current[nextScaleIndex]));
    }
    handleScale({
      zoomDelta: zoomDelta,
      waitForAdjustment: true
    });
  }, [handleScale, scale]);
  var zoomIn = useCallback(function () {
    if (!adjusting) {
      handleScaleButton(true);
    }
  }, [adjusting, handleScaleButton]);
  var zoomOut = useCallback(function () {
    if (!adjusting) {
      handleScaleButton(false);
    }
  }, [adjusting, handleScaleButton]);
  var zoomMap = useCallback(function (newScale) {
    var waitForAdjustment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!adjusting && newScale) {
      handleScale({
        zoomDelta: round(newScale - scale),
        waitForAdjustment: waitForAdjustment
      });
    }
  }, [adjusting, handleScale, scale]);
  var zoomMapToFit = useCallback(function () {
    setAdjusting(true);
    if (containerRef.current && contentElement) {
      var containerRect = containerRef.current.getBoundingClientRect();
      var contentRect = contentElement.getBoundingClientRect();
      var containerHeight = fullscreen ? calcMaxHeight(heightOffset) : containerRect.height;
      var scaledWidth = contentRect.width / scale;
      var scaledHeight = contentRect.height / scale;
      var scaleDelta = Math.min(containerRect.width / scaledWidth, containerHeight / scaledHeight);
      var zoomDelta = round(scaleDelta - scale);
      var zoomRatio = scale + zoomDelta;
      handleScale({
        zoomDelta: zoomDelta
      });
      var newContentWidth = scaledWidth * zoomRatio;
      var newContentHeight = scaledHeight * zoomRatio;
      var translateX = containerRect.width / 2 - newContentWidth / 2;
      var translateY = containerRect.height / 2 - newContentHeight / 2;
      setTranslate({
        x: translateX,
        y: translateY
      });
    }
  }, [containerRef, contentElement, fullscreen, handleScale, heightOffset, scale]);
  var zoomAndCenterOnRect = function zoomAndCenterOnRect(targetRect) {
    var _containerRef$current3;
    setAdjusting(true);
    var _zoomAndCenter2 = zoomAndCenter({
        containerRect: (_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.getBoundingClientRect(),
        contentRect: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
        relativeRect: targetRect,
        scale: scale,
        nextScale: scale > 1.1 ? scale : 1.1
      }),
      newScale = _zoomAndCenter2.scale,
      translateX = _zoomAndCenter2.translateX,
      translateY = _zoomAndCenter2.translateY;
    setScale(newScale);
    setTranslate({
      x: translateX,
      y: translateY
    });
  };
  var handleGrab = function handleGrab(ev) {
    var _ev$touches, _ev$touches$, _ev$touches$2;
    ev.preventDefault();
    ev.stopPropagation();
    if (adjusting) {
      return;
    }
    if (((_ev$touches = ev.touches) === null || _ev$touches === void 0 ? void 0 : _ev$touches.length) === 2) {
      setDistance(distanceBetweenPoints({
        x: ev.touches[0].pageX,
        y: ev.touches[0].pageY
      }, {
        x: ev.touches[1].pageX,
        y: ev.touches[1].pageY
      }));
    }
    var position = {
      x: ev.pageX || ((_ev$touches$ = ev.touches[0]) === null || _ev$touches$ === void 0 ? void 0 : _ev$touches$.pageX) || lastPosition.x,
      y: ev.pageY || ((_ev$touches$2 = ev.touches[0]) === null || _ev$touches$2 === void 0 ? void 0 : _ev$touches$2.pageY) || lastPosition.y
    };
    setGrabbing(true);
    setLastPosition(position);
    setGrabPosition(position);
  };
  var handlePinchMove = function handlePinchMove(ev) {
    var _containerRef$current4;
    ev.stopPropagation();
    ev.preventDefault();
    if (adjusting) {
      return;
    }
    var newDistance = distanceBetweenPoints({
      x: ev.touches[0].pageX,
      y: ev.touches[0].pageY
    }, {
      x: ev.touches[1].pageX,
      y: ev.touches[1].pageY
    });
    debouncedAlignMap({
      fullscreen: fullscreen
    });
    var _zoom2 = zoom({
        containerRect: (_containerRef$current4 = containerRef.current) === null || _containerRef$current4 === void 0 ? void 0 : _containerRef$current4.getBoundingClientRect(),
        contentRect: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
        scale: scale,
        minScale: minScale,
        zoomDelta: newDistance < distance ? -0.03 : 0.03,
        originX: ev.touches[0].pageX,
        originY: ev.touches[0].pageY,
        maxHeight: calcMaxHeight(heightOffset)
      }),
      newScale = _zoom2.scale,
      translateX = _zoom2.translateX,
      translateY = _zoom2.translateY;
    setDistance(newDistance);
    setScale(newScale);
    setTranslate({
      x: translateX,
      y: translateY
    });
  };
  var handleDrag = function handleDrag(ev) {
    if (grabbing) {
      var _ev$touches$3, _ev$touches$4;
      var pageX = ev instanceof MouseEvent && ev.pageX || ev instanceof TouchEvent && ((_ev$touches$3 = ev.touches[0]) === null || _ev$touches$3 === void 0 ? void 0 : _ev$touches$3.pageX) || 0;
      var pageY = ev instanceof MouseEvent && ev.pageY || ev instanceof TouchEvent && ((_ev$touches$4 = ev.touches[0]) === null || _ev$touches$4 === void 0 ? void 0 : _ev$touches$4.pageY) || 0;
      setLastPosition({
        x: pageX || lastPosition.x,
        y: pageY || lastPosition.y
      });
      var pointDifference = distanceBetweenPoints(grabPosition, lastPosition);
      var pixelDelta = 3;
      if (pointDifference > pixelDelta) {
        if (!moving) {
          // Dragging just started, trigger onDragStart if it is defined
          onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart();
        }
        setMoving(true);
      }
      if (moving) {
        var _containerRef$current5;
        var _drag = drag({
            containerRect: (_containerRef$current5 = containerRef.current) === null || _containerRef$current5 === void 0 ? void 0 : _containerRef$current5.getBoundingClientRect(),
            contentRect: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
            deltaX: pageX - (lastPosition.x || 0),
            deltaY: pageY - (lastPosition.y || 0)
          }),
          translateX = _drag.translateX,
          translateY = _drag.translateY;
        setTranslate({
          x: translateX,
          y: translateY
        });
      }
    }
  };
  var handleRelease = function handleRelease(ev) {
    ev.stopPropagation();
    setGrabbing(false);
    if (moving) {
      // Dragging just stopped, trigger onDragStop if it is defined
      // onDragStop is deffered after mouseup
      onDragStop && setTimeout(function () {
        onDragStop();
      }, 0);
    }
    setMoving(false);
  };
  var handleTouchMove = function handleTouchMove(ev) {
    var _ev$touches2, _ev$touches3;
    if (((_ev$touches2 = ev.touches) === null || _ev$touches2 === void 0 ? void 0 : _ev$touches2.length) === 1) handleDrag(ev);
    if (((_ev$touches3 = ev.touches) === null || _ev$touches3 === void 0 ? void 0 : _ev$touches3.length) === 2) handlePinchMove(ev);
  };
  var handleWheel = function handleWheel(ev) {
    var ctrlKey = ev.ctrlKey || ev.metaKey || ev.altKey;
    var shouldZoom = !zoomWithMetaKey || ctrlKey;
    if (shouldZoom) {
      ev.stopPropagation();
      ev.preventDefault();
    }
    if (adjusting) {
      return;
    }
    if (shouldZoom) {
      var _containerRef$current6;
      setShowZoomHint(false);
      var _zoom3 = zoom({
          containerRect: (_containerRef$current6 = containerRef.current) === null || _containerRef$current6 === void 0 ? void 0 : _containerRef$current6.getBoundingClientRect(),
          contentRect: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
          scale: scale,
          minScale: minScale,
          zoomDelta: ev.deltaY > 0 ? -0.05 : 0.05,
          originX: ev.pageX,
          originY: ev.pageY,
          fullscreen: fullscreen,
          maxHeight: calcMaxHeight(heightOffset)
        }),
        newScale = _zoom3.scale,
        translateX = _zoom3.translateX,
        translateY = _zoom3.translateY;
      setScale(newScale);
      setTranslate({
        x: translateX,
        y: translateY
      });
    } else {
      setShowZoomHint(true);
    }
  };
  useMouseEvents$1(containerRef.current, {
    handleDrag: handleDrag,
    handleRelease: handleRelease,
    handleTouchMove: handleTouchMove,
    handleWheel: handleWheel
  });

  // Used to apply state updates delayed
  // Initial state: null -> mousemove event has not yet started
  var _useDelayedState = useDelayedState(null),
    _useDelayedState2 = _slicedToArray(_useDelayedState, 2),
    isIdle = _useDelayedState2[0],
    setIsIdle = _useDelayedState2[1];
  var onMouseMove = function onMouseMove(e) {
    var isToolbarIdle = isControlIdle(e, toolbarReference);
    var isMiniMapIdle = isControlIdle(e, minimapReference);
    var isAdditionalContentIdle = isControlIdle(e, additionalContentReference);
    var currentIdleState = isToolbarIdle && isMiniMapIdle && isAdditionalContentIdle;
    // Apply the idle state when it is false immediately
    // and apply it delayed by 5sec if it is true
    setIsIdle(currentIdleState, currentIdleState ? 5000 : 1);
  };

  // EFFECT LOGIC START -->

  // Make all handlers available via a ref, so we can get their latest value without listing them in the effect dependencies.
  // This makes it more straightforward to trigger effect only when we actually want it.
  var handlers = {
    resetToInitial: resetToInitial,
    zoomAndCenterOnRect: zoomAndCenterOnRect,
    debouncedAlignMap: debouncedAlignMap,
    zoomMapToFit: zoomMapToFit
  };
  var handlersRef = useRef(handlers);
  useEffect(function () {
    handlersRef.current = handlers;
  });

  // Fullscreen on: center diagram, Fullscreen off: reset to initial zoom and scale
  useEffect(function () {
    if (!contentElement) return;
    if (!fullscreen) {
      handlersRef.current.resetToInitial(fitContentHeight);
      if (zoomToFitOnStart) {
        handlersRef.current.zoomMapToFit();
      }
    } else {
      handlersRef.current.debouncedAlignMap({
        fullscreen: fullscreen
      });
    }
  }, [fullscreen, contentElement, fitContentHeight, zoomToFitOnStart]);

  // On mount and when fitContentWidth is passed as Props: reset to initial scale
  // or scale to the diagram width not factoring the height of the diagram
  useEffect(function () {
    if (containerRef !== null && containerRef !== void 0 && containerRef.current && contentElement && fitContentWidth && !(hasResetScaleBeenCalledRef !== null && hasResetScaleBeenCalledRef !== void 0 && hasResetScaleBeenCalledRef.current)) {
      handlersRef.current.resetToInitial(true);
      hasResetScaleBeenCalledRef.current = true;
    }

    // Disabled linting on dependency because hook step needs to be called only when component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, contentElement]);

  // When fitContentHeight props is true and fitContentWidth run, get calculated height of content.
  // timeout is required to wait for contentElement to render completely
  useEffect(function () {
    if (fitContentHeight && hasResetScaleBeenCalledRef.current && !(didFullheightSetupRef !== null && didFullheightSetupRef !== void 0 && didFullheightSetupRef.current)) {
      setTimeout(function () {
        var _containerRef$current7;
        var containerHeight = (_containerRef$current7 = containerRef.current) === null || _containerRef$current7 === void 0 ? void 0 : _containerRef$current7.getBoundingClientRect().height;
        var contentHeight = contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect().height;
        if (contentHeight && containerHeight) {
          setCustomHeight(contentHeight > containerHeight ? contentHeight : containerHeight);
        }
        setMinScale(scale);
        didFullheightSetupRef.current = true;
      }, 0);
    }
  }, [containerRef, contentElement, hasResetScaleBeenCalledRef, fitContentHeight, scale]);

  // on mount add mousemove event listener to correctly apply the idle state
  useEffect(function () {
    if (idleEnabled) {
      document.addEventListener('mousemove', onMouseMove, false);
      return function () {
        return document.removeEventListener('mousemove', onMouseMove, false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // on mount set a timer to fade out the controls after 5000 ms
  // if the mouse
  useEffect(function () {
    if (idleEnabled) {
      var timerId = setTimeout(function () {
        // Check if mousemove event has not yet occured
        // then set fade out the controls
        setIsIdle(function (idle) {
          return idle === null ? true : idle;
        });
      }, 5000);
      return function () {
        return clearTimeout(timerId);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // <--- EFFECT LOGIC END

  var _usePanAndZoomStickyS = usePanAndZoomStickyStyles$1(_objectSpread(_objectSpread({}, stickyToolsDefault), {}, {
      containerRef: containerRef,
      showMiniMap: showMiniMap,
      toolbarRef: toolbarReference,
      enabled: false
    })),
    getStickyStyles = _usePanAndZoomStickyS.getStickyStyles;
  var panAndZoomStickyStyles = useMemo(function () {
    return getStickyStyles();
  }, [getStickyStyles]);
  var isLeftPositionedControls = controlsPosition === 'left';
  var styles = useStyles$2(defaultStyles$2, {}, {
    '&fullscreen': !!fullscreen,
    '&positionLeft': isLeftPositionedControls,
    '&positionLeftFullscreen': isLeftPositionedControls && !!fullscreen
  });
  return /*#__PURE__*/React.createElement(FullHeight$1, {
    fullscreen: fullscreen,
    offset: offset,
    customHeight: customHeight,
    customHeightOffset: customHeightOffset,
    heightOffset: heightOffset,
    heightMargins: heightMargins
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: containerRef,
    role: "presentation",
    id: "pan_zoom_container",
    onTouchStart: handleGrab,
    onMouseDown: handleGrab,
    onMouseEnter: function onMouseEnter() {
      return setIsHoveringContainer(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHoveringContainer(false);
    }
  }, inline(styles, {
    cursor: grabbing && moving ? 'move' : 'inherit'
  })), children({
    translateX: tX,
    translateY: tY,
    scale: scale,
    ref: setContentElement,
    hasTransition: !!adjusting
  }), contentElement && /*#__PURE__*/React.createElement("div", _extends({}, inline(styles('controls'), panAndZoomStickyStyles), {
    className: notPrintableClassName,
    "aria-label": "Controls in ".concat(controlsPosition, " position")
  }), /*#__PURE__*/React.createElement(PanAndZoomToolbar$1, {
    ref: toolbarReference,
    locale: locale,
    scale: scale,
    minScale: minScale,
    maxScale: scaleSteps[0],
    fullscreen: fullscreen,
    onToggleFullscreen: onToggleFullscreen,
    adjusting: adjusting,
    additionalToolbarItemsComponent: additionalToolbarItemsComponent,
    enableHotkeys: isHoveringContainer,
    zoomMapToFit: zoomMapToFit,
    zoomMap: zoomMap,
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    onToggleMiniMap: toggleMiniMap,
    showMiniMap: showMiniMap,
    isIdle: isIdle,
    position: controlsPosition
  }), showMiniMap && miniMapSvg && /*#__PURE__*/React.createElement(MiniMap$1, {
    ref: minimapReference,
    diagramSize: contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect(),
    viewSize: (_containerRef$current8 = containerRef.current) === null || _containerRef$current8 === void 0 ? void 0 : _containerRef$current8.getBoundingClientRect(),
    svg: miniMapSvg,
    translate: translate,
    setTranslate: setTranslate,
    adjusting: adjusting,
    width: MINI_MAP_WIDTH,
    height: MINI_MAP_HEIGHT,
    isIdle: isIdle
  })), zoomWithMetaKey && /*#__PURE__*/React.createElement(ZoomHint$1, {
    visible: moving && !adjusting && showZoomHint,
    locale: locale
  })), fullscreen && AdditionalContentComponent ? /*#__PURE__*/React.createElement(AdditionalContentComponent, {
    containerRef: additionalContentReference,
    isIdle: isIdle
  }) : null);
}
var defaultStyles$2 = function defaultStyles(_ref5) {
  var padding = _ref5.padding,
    zIndex = _ref5.zIndex;
  return {
    height: '100%',
    position: 'relative',
    userSelect: 'none',
    /*
      another approach for fixing error logging while zooming the diagram
      https://github.com/facebook/react/issues/6436#issuecomment-477819667
    */
    touchAction: 'none',
    overflow: 'hidden',
    controls: {
      position: 'absolute',
      pointerEvents: 'all',
      width: 0,
      top: 0,
      right: 0,
      bottom: 0,
      /*
        We use this very high z-index is to reserve the z-index space 0-99 for elements in the generic content of PanAndZoom .
        (For example journey maps use sticky headers that requires z indices.)
        however it does need to be below the drop downs of 99 in the action bar above the model
      */
      zIndex: zIndex.contentConsumptionControls,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      flexWrap: 'wrap-reverse',
      padding: '0 2px 2px 0'
    },
    '&fullscreen': {
      controls: {
        zIndex: zIndex.fullscreenContentConsumptionControls,
        top: '58px',
        right: padding.normal,
        bottom: padding.normal,
        padding: '0 0 2px 2px'
      }
    },
    '&positionLeft': {
      controls: {
        flexWrap: 'wrap',
        right: 'unset'
      }
    },
    '&positionLeftFullscreen': {
      controls: {
        right: 'unset',
        left: padding.normal
      }
    }
  };
};
var PanAndZoom$1 = /*#__PURE__*/forwardRef(PanAndZoom);// this allows to compare previous prop value just like componentWillReceiveProps
function usePrevious(value, initialValue) {
  var ref = useRef(initialValue);
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}var _excluded = ["fullscreenHeader", "inFullscreenMode", "onToggleFullscreen"];
var offset = function offset(rectPrevContainer, rectNextContainer) {
  if (!rectNextContainer || !rectPrevContainer) {
    return {
      deltaX: 0,
      deltaY: 0
    };
  }
  var rectPrev = rectPrevContainer.getBoundingClientRect();
  var rectNext = rectNextContainer.getBoundingClientRect();
  return {
    deltaX: rectPrev.left - rectNext.left,
    deltaY: rectPrev.top - rectNext.top
  };
};
var FullscreenPanAndZoom = function FullscreenPanAndZoom(_ref) {
  var fullscreenHeader = _ref.fullscreenHeader,
    _ref$inFullscreenMode = _ref.inFullscreenMode,
    inFullscreenMode = _ref$inFullscreenMode === void 0 ? false : _ref$inFullscreenMode,
    onToggleFullscreen = _ref.onToggleFullscreen,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAnchoring = _useState2[0],
    setIsAnchoring = _useState2[1];
  var panAndZoomRef = useRef(null);
  var measureRef = useRef();
  var previousFullScreen = usePrevious(inFullscreenMode);
  var styles = useStyles$2(defaultStyles$1, {}, {
    '&fullscreen': !!inFullscreenMode
  });
  useEffect(function () {
    var handleKeyUp = function handleKeyUp(ev) {
      if (inFullscreenMode && ev.keyCode === ESCAPE) {
        onToggleFullscreen === null || onToggleFullscreen === void 0 ? void 0 : onToggleFullscreen();
      }
    };
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [inFullscreenMode, onToggleFullscreen]);
  useEffect(function () {
    // isAnchoring is the state in-between toggling the fullscreen on and off,
    // where refs are mounting and can't be measured
    setIsAnchoring(inFullscreenMode && !previousFullScreen);
  }, [inFullscreenMode, previousFullScreen]);
  return /*#__PURE__*/React.createElement("div", _extends({}, styles, {
    "aria-label": inFullscreenMode ? 'Fullscreen on' : 'Fullscreen off'
  }), inFullscreenMode && fullscreenHeader, /*#__PURE__*/React.createElement(PanAndZoom$1, _extends({}, rest, {
    ref: panAndZoomRef,
    inFullscreenMode: !isAnchoring && inFullscreenMode,
    onToggleFullscreen: onToggleFullscreen,
    offset: isAnchoring ? offset(panAndZoomRef.current, measureRef.current) : undefined
  })), /*#__PURE__*/React.createElement("div", _extends({
    ref: measureRef
  }, styles('measure'))));
};
var defaultStyles$1 = function defaultStyles(_ref2) {
  var color = _ref2.color,
    zIndex = _ref2.zIndex;
  return {
    '&fullscreen': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 3,
      background: color.surface,
      zIndex: zIndex.fullscreenContentConsumption,
      overflow: 'hidden',
      measure: {
        position: 'absolute',
        visibility: 'hidden',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      }
    }
  };
};
var FullscreenPanAndZoom$1 = FullscreenPanAndZoom;var renderPanAndZoomContent = function renderPanAndZoomContent(children) {
  return function (_ref) {
    var translateX = _ref.translateX,
      translateY = _ref.translateY,
      scale = _ref.scale,
      hasTransition = _ref.hasTransition,
      ref = _ref.ref;
    var styles = useStyles$1(defaultStyles, {}, {
      '&transition': !!hasTransition
    });
    return /*#__PURE__*/React.createElement("div", _extends({
      id: "pan_zoom"
    }, inline(styles, {
      transform: "translate(".concat(translateX, "px, ").concat(translateY, "px) scale(").concat(scale, ")")
    }), {
      ref: ref,
      draggable: false
    }), children);
  };
};
var defaultStyles = function defaultStyles() {
  return {
    transformOrigin: '0 0',
    display: 'inline-block',
    userSelect: 'none',
    '&transition': {
      transition: '0.2s ease-in'
    }
  };
};
var renderPanAndZoomContent$1 = renderPanAndZoomContent;export{BooleanField as BooleanInput,FullscreenPanAndZoom$1 as ContentConsumption,CurrencyInput,DateInput$1 as DateInput,DateTimeInput$1 as DateTimeInput,DurationInput$1 as DurationInput,EmailInput$1 as EmailInput,FileInput,InlineTag,List,MultiSelect,NumberInput$1 as NumberInput,Select,Slider$1 as Slider,TextInput$1 as TextInput,Textarea$1 as Textarea,TimeInput$1 as TimeInput,ToggleSwitch,UrlInput$1 as UrlInput,renderPanAndZoomContent$1 as renderContentConsumptionContent};//# sourceMappingURL=future.esm.js.map
